/* tslint:disable */
/* eslint-disable */
/**
 * CVPnet API
 * The CVPnet API allows you to retrieve preprocessed data of your club as well as writing back into CVPnet for specific use cases. Write functions containing input validation as well as a wide range of optional parameters. To use the interface, you must first activate it in CVPnet and create an API key for a user. Define rights for the API user to limit the API calls.    If more api calls are required feel free to contact us.
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const EventType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
};
/**
 * ApiLoginApi - axios parameter creator
 * @export
 */
export const ApiLoginApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginAppLogin: (account, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/ApiLogin/AppLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(account, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginPersonenLogin: (personenLogin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/ApiLogin/PersonenLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(personenLogin, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginVereinsLogin: (vereinsLogin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/ApiLogin/VereinsLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(vereinsLogin, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ApiLoginApi - functional programming interface
 * @export
 */
export const ApiLoginApiFp = function (configuration) {
    const localVarAxiosParamCreator = ApiLoginApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginAppLogin(account, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiLoginAppLogin(account, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginPersonenLogin(personenLogin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiLoginPersonenLogin(personenLogin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginVereinsLogin(vereinsLogin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiLoginVereinsLogin(vereinsLogin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ApiLoginApi - factory interface
 * @export
 */
export const ApiLoginApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ApiLoginApiFp(configuration);
    return {
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginAppLogin(account, options) {
            return localVarFp.apiLoginAppLogin(account, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginPersonenLogin(personenLogin, options) {
            return localVarFp.apiLoginPersonenLogin(personenLogin, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLoginVereinsLogin(vereinsLogin, options) {
            return localVarFp.apiLoginVereinsLogin(vereinsLogin, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ApiLoginApi - object-oriented interface
 * @export
 * @class ApiLoginApi
 * @extends {BaseAPI}
 */
export class ApiLoginApi extends BaseAPI {
    /**
     *
     * @param {AppLoginViewModel} [account]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiLoginApi
     */
    apiLoginAppLogin(account, options) {
        return ApiLoginApiFp(this.configuration).apiLoginAppLogin(account, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonenLoginViewModel} [personenLogin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiLoginApi
     */
    apiLoginPersonenLogin(personenLogin, options) {
        return ApiLoginApiFp(this.configuration).apiLoginPersonenLogin(personenLogin, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VereinsLoginViewModel} [vereinsLogin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiLoginApi
     */
    apiLoginVereinsLogin(vereinsLogin, options) {
        return ApiLoginApiFp(this.configuration).apiLoginVereinsLogin(vereinsLogin, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AppLoginApi - axios parameter creator
 * @export
 */
export const AppLoginApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginClubLogin: (clubLoginId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubLoginId' is not null or undefined
            assertParamExists('appLoginClubLogin', 'clubLoginId', clubLoginId);
            const localVarPath = `/api/AppLogin/ClubLogins/{clubLoginId}/Login`
                .replace(`{${"clubLoginId"}}`, encodeURIComponent(String(clubLoginId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} confirmationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginConfirmAccountDeletion: (confirmationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'confirmationId' is not null or undefined
            assertParamExists('appLoginConfirmAccountDeletion', 'confirmationId', confirmationId);
            const localVarPath = `/api/AppLogin/ConfirmAccountDeletion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (confirmationId !== undefined) {
                localVarQueryParameter['confirmationId'] = confirmationId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginConfirmLogin: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('appLoginConfirmLogin', 'id', id);
            const localVarPath = `/api/AppLogin/ConfirmLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} adrNumber
         * @param {string} password
         * @param {boolean} savePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginCreateClubLogin: (clubNumber, adrNumber, password, savePassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('appLoginCreateClubLogin', 'clubNumber', clubNumber);
            // verify required parameter 'adrNumber' is not null or undefined
            assertParamExists('appLoginCreateClubLogin', 'adrNumber', adrNumber);
            // verify required parameter 'password' is not null or undefined
            assertParamExists('appLoginCreateClubLogin', 'password', password);
            // verify required parameter 'savePassword' is not null or undefined
            assertParamExists('appLoginCreateClubLogin', 'savePassword', savePassword);
            const localVarPath = `/api/AppLogin/ClubLogins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            if (adrNumber !== undefined) {
                localVarQueryParameter['adrNumber'] = adrNumber;
            }
            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }
            if (savePassword !== undefined) {
                localVarQueryParameter['savePassword'] = savePassword;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginCreateNewLogin: (account, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/AppLogin/CreateNewLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(account, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginDeleteClubLogin: (clubLoginId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubLoginId' is not null or undefined
            assertParamExists('appLoginDeleteClubLogin', 'clubLoginId', clubLoginId);
            const localVarPath = `/api/AppLogin/ClubLogins/{clubLoginId}`
                .replace(`{${"clubLoginId"}}`, encodeURIComponent(String(clubLoginId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetClubLogin: (clubLoginId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubLoginId' is not null or undefined
            assertParamExists('appLoginGetClubLogin', 'clubLoginId', clubLoginId);
            const localVarPath = `/api/AppLogin/ClubLogins/{clubLoginId}`
                .replace(`{${"clubLoginId"}}`, encodeURIComponent(String(clubLoginId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetClubLogins: (logoWidth, logoHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/AppLogin/ClubLogins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetConvertedPassword: (password, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'password' is not null or undefined
            assertParamExists('appLoginGetConvertedPassword', 'password', password);
            const localVarPath = `/api/AppLogin/GetConvertPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLogin: (account, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/AppLogin/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(account, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} loginId
         * @param {string} lastLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLoginWithLastLoginId: (loginId, lastLoginId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'loginId' is not null or undefined
            assertParamExists('appLoginLoginWithLastLoginId', 'loginId', loginId);
            // verify required parameter 'lastLoginId' is not null or undefined
            assertParamExists('appLoginLoginWithLastLoginId', 'lastLoginId', lastLoginId);
            const localVarPath = `/api/AppLogin/LoginWithLastLoginId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (loginId !== undefined) {
                localVarQueryParameter['loginId'] = loginId;
            }
            if (lastLoginId !== undefined) {
                localVarQueryParameter['lastLoginId'] = lastLoginId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} loginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLogout: (loginId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'loginId' is not null or undefined
            assertParamExists('appLoginLogout', 'loginId', loginId);
            const localVarPath = `/api/AppLogin/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (loginId !== undefined) {
                localVarQueryParameter['loginId'] = loginId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubLoginId
         * @param {number} newSortOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginReorderClubLogin: (clubLoginId, newSortOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubLoginId' is not null or undefined
            assertParamExists('appLoginReorderClubLogin', 'clubLoginId', clubLoginId);
            // verify required parameter 'newSortOrder' is not null or undefined
            assertParamExists('appLoginReorderClubLogin', 'newSortOrder', newSortOrder);
            const localVarPath = `/api/AppLogin/ClubLogins/{clubLoginId}/Reorder`
                .replace(`{${"clubLoginId"}}`, encodeURIComponent(String(clubLoginId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (newSortOrder !== undefined) {
                localVarQueryParameter['newSortOrder'] = newSortOrder;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginRequestAccountDeletion: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/AppLogin/RequestAccountDeletion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AppLoginViewModel} [appLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginRequestAccountDeletionMail: (appLogin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/AppLogin/RequestAccountDeletionMail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(appLogin, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginResetAppPassword: (login, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'login' is not null or undefined
            assertParamExists('appLoginResetAppPassword', 'login', login);
            const localVarPath = `/api/AppLogin/ResetAppPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (login !== undefined) {
                localVarQueryParameter['login'] = login;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} oldPassword
         * @param {string} newLogin
         * @param {string} newPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginSaveAppLogin: (oldPassword, newLogin, newPassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'oldPassword' is not null or undefined
            assertParamExists('appLoginSaveAppLogin', 'oldPassword', oldPassword);
            // verify required parameter 'newLogin' is not null or undefined
            assertParamExists('appLoginSaveAppLogin', 'newLogin', newLogin);
            // verify required parameter 'newPassword' is not null or undefined
            assertParamExists('appLoginSaveAppLogin', 'newPassword', newPassword);
            const localVarPath = `/api/AppLogin/SaveAppLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (oldPassword !== undefined) {
                localVarQueryParameter['oldPassword'] = oldPassword;
            }
            if (newLogin !== undefined) {
                localVarQueryParameter['newLogin'] = newLogin;
            }
            if (newPassword !== undefined) {
                localVarQueryParameter['newPassword'] = newPassword;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubLoginId
         * @param {string} password
         * @param {string} oldPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginSaveClubLoginPassword: (clubLoginId, password, oldPassword, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubLoginId' is not null or undefined
            assertParamExists('appLoginSaveClubLoginPassword', 'clubLoginId', clubLoginId);
            // verify required parameter 'password' is not null or undefined
            assertParamExists('appLoginSaveClubLoginPassword', 'password', password);
            // verify required parameter 'oldPassword' is not null or undefined
            assertParamExists('appLoginSaveClubLoginPassword', 'oldPassword', oldPassword);
            const localVarPath = `/api/AppLogin/ClubLogins/{clubLoginId}/Password`
                .replace(`{${"clubLoginId"}}`, encodeURIComponent(String(clubLoginId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }
            if (oldPassword !== undefined) {
                localVarQueryParameter['oldPassword'] = oldPassword;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AppLoginApi - functional programming interface
 * @export
 */
export const AppLoginApiFp = function (configuration) {
    const localVarAxiosParamCreator = AppLoginApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginClubLogin(clubLoginId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginClubLogin(clubLoginId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} confirmationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginConfirmAccountDeletion(confirmationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginConfirmAccountDeletion(confirmationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginConfirmLogin(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginConfirmLogin(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} adrNumber
         * @param {string} password
         * @param {boolean} savePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginCreateClubLogin(clubNumber, adrNumber, password, savePassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginCreateClubLogin(clubNumber, adrNumber, password, savePassword, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginCreateNewLogin(account, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginCreateNewLogin(account, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginDeleteClubLogin(clubLoginId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginDeleteClubLogin(clubLoginId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetClubLogin(clubLoginId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginGetClubLogin(clubLoginId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetClubLogins(logoWidth, logoHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginGetClubLogins(logoWidth, logoHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetConvertedPassword(password, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginGetConvertedPassword(password, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLogin(account, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginLogin(account, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} loginId
         * @param {string} lastLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLoginWithLastLoginId(loginId, lastLoginId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginLoginWithLastLoginId(loginId, lastLoginId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} loginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLogout(loginId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginLogout(loginId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {number} newSortOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginReorderClubLogin(clubLoginId, newSortOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginReorderClubLogin(clubLoginId, newSortOrder, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginRequestAccountDeletion(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginRequestAccountDeletion(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {AppLoginViewModel} [appLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginRequestAccountDeletionMail(appLogin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginRequestAccountDeletionMail(appLogin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginResetAppPassword(login, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginResetAppPassword(login, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} oldPassword
         * @param {string} newLogin
         * @param {string} newPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginSaveAppLogin(oldPassword, newLogin, newPassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginSaveAppLogin(oldPassword, newLogin, newPassword, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {string} password
         * @param {string} oldPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginSaveClubLoginPassword(clubLoginId, password, oldPassword, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.appLoginSaveClubLoginPassword(clubLoginId, password, oldPassword, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AppLoginApi - factory interface
 * @export
 */
export const AppLoginApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AppLoginApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginClubLogin(clubLoginId, options) {
            return localVarFp.appLoginClubLogin(clubLoginId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} confirmationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginConfirmAccountDeletion(confirmationId, options) {
            return localVarFp.appLoginConfirmAccountDeletion(confirmationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginConfirmLogin(id, options) {
            return localVarFp.appLoginConfirmLogin(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} adrNumber
         * @param {string} password
         * @param {boolean} savePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginCreateClubLogin(clubNumber, adrNumber, password, savePassword, options) {
            return localVarFp.appLoginCreateClubLogin(clubNumber, adrNumber, password, savePassword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginCreateNewLogin(account, options) {
            return localVarFp.appLoginCreateNewLogin(account, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginDeleteClubLogin(clubLoginId, options) {
            return localVarFp.appLoginDeleteClubLogin(clubLoginId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetClubLogin(clubLoginId, options) {
            return localVarFp.appLoginGetClubLogin(clubLoginId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetClubLogins(logoWidth, logoHeigth, options) {
            return localVarFp.appLoginGetClubLogins(logoWidth, logoHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginGetConvertedPassword(password, options) {
            return localVarFp.appLoginGetConvertedPassword(password, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLogin(account, options) {
            return localVarFp.appLoginLogin(account, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} loginId
         * @param {string} lastLoginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLoginWithLastLoginId(loginId, lastLoginId, options) {
            return localVarFp.appLoginLoginWithLastLoginId(loginId, lastLoginId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} loginId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginLogout(loginId, options) {
            return localVarFp.appLoginLogout(loginId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {number} newSortOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginReorderClubLogin(clubLoginId, newSortOrder, options) {
            return localVarFp.appLoginReorderClubLogin(clubLoginId, newSortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginRequestAccountDeletion(options) {
            return localVarFp.appLoginRequestAccountDeletion(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AppLoginViewModel} [appLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginRequestAccountDeletionMail(appLogin, options) {
            return localVarFp.appLoginRequestAccountDeletionMail(appLogin, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginResetAppPassword(login, options) {
            return localVarFp.appLoginResetAppPassword(login, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} oldPassword
         * @param {string} newLogin
         * @param {string} newPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginSaveAppLogin(oldPassword, newLogin, newPassword, options) {
            return localVarFp.appLoginSaveAppLogin(oldPassword, newLogin, newPassword, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubLoginId
         * @param {string} password
         * @param {string} oldPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appLoginSaveClubLoginPassword(clubLoginId, password, oldPassword, options) {
            return localVarFp.appLoginSaveClubLoginPassword(clubLoginId, password, oldPassword, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AppLoginApi - object-oriented interface
 * @export
 * @class AppLoginApi
 * @extends {BaseAPI}
 */
export class AppLoginApi extends BaseAPI {
    /**
     *
     * @param {number} clubLoginId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginClubLogin(clubLoginId, options) {
        return AppLoginApiFp(this.configuration).appLoginClubLogin(clubLoginId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} confirmationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginConfirmAccountDeletion(confirmationId, options) {
        return AppLoginApiFp(this.configuration).appLoginConfirmAccountDeletion(confirmationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginConfirmLogin(id, options) {
        return AppLoginApiFp(this.configuration).appLoginConfirmLogin(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} adrNumber
     * @param {string} password
     * @param {boolean} savePassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginCreateClubLogin(clubNumber, adrNumber, password, savePassword, options) {
        return AppLoginApiFp(this.configuration).appLoginCreateClubLogin(clubNumber, adrNumber, password, savePassword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppLoginViewModel} [account]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginCreateNewLogin(account, options) {
        return AppLoginApiFp(this.configuration).appLoginCreateNewLogin(account, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubLoginId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginDeleteClubLogin(clubLoginId, options) {
        return AppLoginApiFp(this.configuration).appLoginDeleteClubLogin(clubLoginId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubLoginId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginGetClubLogin(clubLoginId, options) {
        return AppLoginApiFp(this.configuration).appLoginGetClubLogin(clubLoginId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [logoWidth]
     * @param {number} [logoHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginGetClubLogins(logoWidth, logoHeigth, options) {
        return AppLoginApiFp(this.configuration).appLoginGetClubLogins(logoWidth, logoHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginGetConvertedPassword(password, options) {
        return AppLoginApiFp(this.configuration).appLoginGetConvertedPassword(password, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppLoginViewModel} [account]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginLogin(account, options) {
        return AppLoginApiFp(this.configuration).appLoginLogin(account, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} loginId
     * @param {string} lastLoginId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginLoginWithLastLoginId(loginId, lastLoginId, options) {
        return AppLoginApiFp(this.configuration).appLoginLoginWithLastLoginId(loginId, lastLoginId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} loginId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginLogout(loginId, options) {
        return AppLoginApiFp(this.configuration).appLoginLogout(loginId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubLoginId
     * @param {number} newSortOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginReorderClubLogin(clubLoginId, newSortOrder, options) {
        return AppLoginApiFp(this.configuration).appLoginReorderClubLogin(clubLoginId, newSortOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginRequestAccountDeletion(options) {
        return AppLoginApiFp(this.configuration).appLoginRequestAccountDeletion(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AppLoginViewModel} [appLogin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginRequestAccountDeletionMail(appLogin, options) {
        return AppLoginApiFp(this.configuration).appLoginRequestAccountDeletionMail(appLogin, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginResetAppPassword(login, options) {
        return AppLoginApiFp(this.configuration).appLoginResetAppPassword(login, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} oldPassword
     * @param {string} newLogin
     * @param {string} newPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginSaveAppLogin(oldPassword, newLogin, newPassword, options) {
        return AppLoginApiFp(this.configuration).appLoginSaveAppLogin(oldPassword, newLogin, newPassword, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubLoginId
     * @param {string} password
     * @param {string} oldPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppLoginApi
     */
    appLoginSaveClubLoginPassword(clubLoginId, password, oldPassword, options) {
        return AppLoginApiFp(this.configuration).appLoginSaveClubLoginPassword(clubLoginId, password, oldPassword, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ClubDataApi - axios parameter creator
 * @export
 */
export const ClubDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubDataGetClubData: (logoWidth, logoHeigth, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'logoWidth' is not null or undefined
            assertParamExists('clubDataGetClubData', 'logoWidth', logoWidth);
            // verify required parameter 'logoHeigth' is not null or undefined
            assertParamExists('clubDataGetClubData', 'logoHeigth', logoHeigth);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('clubDataGetClubData', 'clubNumber', clubNumber);
            const localVarPath = `/api/ClubData/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClubDataApi - functional programming interface
 * @export
 */
export const ClubDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClubDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubDataGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clubDataGetClubData(logoWidth, logoHeigth, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClubDataApi - factory interface
 * @export
 */
export const ClubDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClubDataApiFp(configuration);
    return {
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubDataGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return localVarFp.clubDataGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClubDataApi - object-oriented interface
 * @export
 * @class ClubDataApi
 * @extends {BaseAPI}
 */
export class ClubDataApi extends BaseAPI {
    /**
     *
     * @param {number} logoWidth
     * @param {number} logoHeigth
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClubDataApi
     */
    clubDataGetClubData(logoWidth, logoHeigth, clubNumber, options) {
        return ClubDataApiFp(this.configuration).clubDataGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ClubNewsApi - axios parameter creator
 * @export
 */
export const ClubNewsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {number} [daysBefore]
         * @param {number} [maxNewsNumber]
         * @param {boolean} [sortDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsGetClubNews: (clubNumber, daysBefore, maxNewsNumber, sortDescending, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('clubNewsGetClubNews', 'clubNumber', clubNumber);
            const localVarPath = `/api/ClubNews/{clubNumber}/ClubNews`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (daysBefore !== undefined) {
                localVarQueryParameter['daysBefore'] = daysBefore;
            }
            if (maxNewsNumber !== undefined) {
                localVarQueryParameter['maxNewsNumber'] = maxNewsNumber;
            }
            if (sortDescending !== undefined) {
                localVarQueryParameter['sortDescending'] = sortDescending;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} [daysBefore]
         * @param {number} [daysActualNews]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsGetNumberClubNews: (clubNumber, daysBefore, daysActualNews, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('clubNewsGetNumberClubNews', 'clubNumber', clubNumber);
            const localVarPath = `/api/ClubNews/{clubNumber}/NumberClubNews`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (daysBefore !== undefined) {
                localVarQueryParameter['daysBefore'] = daysBefore;
            }
            if (daysActualNews !== undefined) {
                localVarQueryParameter['daysActualNews'] = daysActualNews;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} newsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsMarkNewsAsRead: (clubNumber, newsId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('clubNewsMarkNewsAsRead', 'clubNumber', clubNumber);
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('clubNewsMarkNewsAsRead', 'newsId', newsId);
            const localVarPath = `/api/ClubNews/{clubNumber}/MarkNewsAsRead/{newsId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ClubNewsApi - functional programming interface
 * @export
 */
export const ClubNewsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ClubNewsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {number} [daysBefore]
         * @param {number} [maxNewsNumber]
         * @param {boolean} [sortDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsGetClubNews(clubNumber, daysBefore, maxNewsNumber, sortDescending, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clubNewsGetClubNews(clubNumber, daysBefore, maxNewsNumber, sortDescending, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [daysBefore]
         * @param {number} [daysActualNews]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsGetNumberClubNews(clubNumber, daysBefore, daysActualNews, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clubNewsGetNumberClubNews(clubNumber, daysBefore, daysActualNews, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} newsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsMarkNewsAsRead(clubNumber, newsId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clubNewsMarkNewsAsRead(clubNumber, newsId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ClubNewsApi - factory interface
 * @export
 */
export const ClubNewsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ClubNewsApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {number} [daysBefore]
         * @param {number} [maxNewsNumber]
         * @param {boolean} [sortDescending]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsGetClubNews(clubNumber, daysBefore, maxNewsNumber, sortDescending, options) {
            return localVarFp.clubNewsGetClubNews(clubNumber, daysBefore, maxNewsNumber, sortDescending, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [daysBefore]
         * @param {number} [daysActualNews]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsGetNumberClubNews(clubNumber, daysBefore, daysActualNews, options) {
            return localVarFp.clubNewsGetNumberClubNews(clubNumber, daysBefore, daysActualNews, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} newsId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clubNewsMarkNewsAsRead(clubNumber, newsId, options) {
            return localVarFp.clubNewsMarkNewsAsRead(clubNumber, newsId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ClubNewsApi - object-oriented interface
 * @export
 * @class ClubNewsApi
 * @extends {BaseAPI}
 */
export class ClubNewsApi extends BaseAPI {
    /**
     *
     * @param {number} clubNumber
     * @param {number} [daysBefore]
     * @param {number} [maxNewsNumber]
     * @param {boolean} [sortDescending]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClubNewsApi
     */
    clubNewsGetClubNews(clubNumber, daysBefore, maxNewsNumber, sortDescending, options) {
        return ClubNewsApiFp(this.configuration).clubNewsGetClubNews(clubNumber, daysBefore, maxNewsNumber, sortDescending, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} [daysBefore]
     * @param {number} [daysActualNews]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClubNewsApi
     */
    clubNewsGetNumberClubNews(clubNumber, daysBefore, daysActualNews, options) {
        return ClubNewsApiFp(this.configuration).clubNewsGetNumberClubNews(clubNumber, daysBefore, daysActualNews, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} newsId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClubNewsApi
     */
    clubNewsMarkNewsAsRead(clubNumber, newsId, options) {
        return ClubNewsApiFp(this.configuration).clubNewsMarkNewsAsRead(clubNumber, newsId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ConfigApi - axios parameter creator
 * @export
 */
export const ConfigApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} favoriteId
         * @param {string} favName
         * @param {string} favFunction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configCreateFavoriteFunction: (favoriteId, favName, favFunction, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'favoriteId' is not null or undefined
            assertParamExists('configCreateFavoriteFunction', 'favoriteId', favoriteId);
            // verify required parameter 'favName' is not null or undefined
            assertParamExists('configCreateFavoriteFunction', 'favName', favName);
            // verify required parameter 'favFunction' is not null or undefined
            assertParamExists('configCreateFavoriteFunction', 'favFunction', favFunction);
            const localVarPath = `/api/Config/FavoriteFunction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (favoriteId !== undefined) {
                localVarQueryParameter['favoriteId'] = favoriteId;
            }
            if (favName !== undefined) {
                localVarQueryParameter['favName'] = favName;
            }
            if (favFunction !== undefined) {
                localVarQueryParameter['favFunction'] = favFunction;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} favId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configDeleteFavoriteFunction: (favId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'favId' is not null or undefined
            assertParamExists('configDeleteFavoriteFunction', 'favId', favId);
            const localVarPath = `/api/Config/FavoriteFunction/{favId}`
                .replace(`{${"favId"}}`, encodeURIComponent(String(favId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetFavoriteFunctions: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/Config/FavoriteFunction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetIsDisplayDarkMode: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/Config/GetIsDisplayDarkMode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetLastDeviceCalenderIdAndroid: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/Config/GetLastDeviceCalenderIdAndroid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetLastDeviceCalenderIdIos: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/Config/GetLastDeviceCalenderIdIos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} favId
         * @param {number} newSortOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configReorderFavoriteFunction: (favId, newSortOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'favId' is not null or undefined
            assertParamExists('configReorderFavoriteFunction', 'favId', favId);
            // verify required parameter 'newSortOrder' is not null or undefined
            assertParamExists('configReorderFavoriteFunction', 'newSortOrder', newSortOrder);
            const localVarPath = `/api/Config/FavoriteFunction/{favId}/reorder`
                .replace(`{${"favId"}}`, encodeURIComponent(String(favId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (newSortOrder !== undefined) {
                localVarQueryParameter['newSortOrder'] = newSortOrder;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} isDarkMode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveDisplayMode: (isDarkMode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'isDarkMode' is not null or undefined
            assertParamExists('configSaveDisplayMode', 'isDarkMode', isDarkMode);
            const localVarPath = `/api/Config/SaveDisplayMode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (isDarkMode !== undefined) {
                localVarQueryParameter['isDarkMode'] = isDarkMode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} calendarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveLastDeviceCalenderIdAndroid: (calendarId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('configSaveLastDeviceCalenderIdAndroid', 'calendarId', calendarId);
            const localVarPath = `/api/Config/SaveLastDeviceCalenderIdAndroid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (calendarId !== undefined) {
                localVarQueryParameter['calendarId'] = calendarId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} calendarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveLastDeviceCalenderIdIos: (calendarId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'calendarId' is not null or undefined
            assertParamExists('configSaveLastDeviceCalenderIdIos', 'calendarId', calendarId);
            const localVarPath = `/api/Config/SaveLastDeviceCalenderIdIos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (calendarId !== undefined) {
                localVarQueryParameter['calendarId'] = calendarId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ConfigApi - functional programming interface
 * @export
 */
export const ConfigApiFp = function (configuration) {
    const localVarAxiosParamCreator = ConfigApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} favoriteId
         * @param {string} favName
         * @param {string} favFunction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configCreateFavoriteFunction(favoriteId, favName, favFunction, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configCreateFavoriteFunction(favoriteId, favName, favFunction, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} favId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configDeleteFavoriteFunction(favId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configDeleteFavoriteFunction(favId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetFavoriteFunctions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configGetFavoriteFunctions(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetIsDisplayDarkMode(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configGetIsDisplayDarkMode(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetLastDeviceCalenderIdAndroid(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configGetLastDeviceCalenderIdAndroid(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetLastDeviceCalenderIdIos(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configGetLastDeviceCalenderIdIos(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} favId
         * @param {number} newSortOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configReorderFavoriteFunction(favId, newSortOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configReorderFavoriteFunction(favId, newSortOrder, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} isDarkMode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveDisplayMode(isDarkMode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configSaveDisplayMode(isDarkMode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} calendarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveLastDeviceCalenderIdAndroid(calendarId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configSaveLastDeviceCalenderIdAndroid(calendarId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} calendarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveLastDeviceCalenderIdIos(calendarId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.configSaveLastDeviceCalenderIdIos(calendarId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ConfigApi - factory interface
 * @export
 */
export const ConfigApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ConfigApiFp(configuration);
    return {
        /**
         *
         * @param {number} favoriteId
         * @param {string} favName
         * @param {string} favFunction
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configCreateFavoriteFunction(favoriteId, favName, favFunction, options) {
            return localVarFp.configCreateFavoriteFunction(favoriteId, favName, favFunction, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} favId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configDeleteFavoriteFunction(favId, options) {
            return localVarFp.configDeleteFavoriteFunction(favId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetFavoriteFunctions(options) {
            return localVarFp.configGetFavoriteFunctions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetIsDisplayDarkMode(options) {
            return localVarFp.configGetIsDisplayDarkMode(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetLastDeviceCalenderIdAndroid(options) {
            return localVarFp.configGetLastDeviceCalenderIdAndroid(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configGetLastDeviceCalenderIdIos(options) {
            return localVarFp.configGetLastDeviceCalenderIdIos(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} favId
         * @param {number} newSortOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configReorderFavoriteFunction(favId, newSortOrder, options) {
            return localVarFp.configReorderFavoriteFunction(favId, newSortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} isDarkMode
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveDisplayMode(isDarkMode, options) {
            return localVarFp.configSaveDisplayMode(isDarkMode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} calendarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveLastDeviceCalenderIdAndroid(calendarId, options) {
            return localVarFp.configSaveLastDeviceCalenderIdAndroid(calendarId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} calendarId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configSaveLastDeviceCalenderIdIos(calendarId, options) {
            return localVarFp.configSaveLastDeviceCalenderIdIos(calendarId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ConfigApi - object-oriented interface
 * @export
 * @class ConfigApi
 * @extends {BaseAPI}
 */
export class ConfigApi extends BaseAPI {
    /**
     *
     * @param {number} favoriteId
     * @param {string} favName
     * @param {string} favFunction
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configCreateFavoriteFunction(favoriteId, favName, favFunction, options) {
        return ConfigApiFp(this.configuration).configCreateFavoriteFunction(favoriteId, favName, favFunction, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} favId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configDeleteFavoriteFunction(favId, options) {
        return ConfigApiFp(this.configuration).configDeleteFavoriteFunction(favId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configGetFavoriteFunctions(options) {
        return ConfigApiFp(this.configuration).configGetFavoriteFunctions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configGetIsDisplayDarkMode(options) {
        return ConfigApiFp(this.configuration).configGetIsDisplayDarkMode(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configGetLastDeviceCalenderIdAndroid(options) {
        return ConfigApiFp(this.configuration).configGetLastDeviceCalenderIdAndroid(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configGetLastDeviceCalenderIdIos(options) {
        return ConfigApiFp(this.configuration).configGetLastDeviceCalenderIdIos(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} favId
     * @param {number} newSortOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configReorderFavoriteFunction(favId, newSortOrder, options) {
        return ConfigApiFp(this.configuration).configReorderFavoriteFunction(favId, newSortOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} isDarkMode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configSaveDisplayMode(isDarkMode, options) {
        return ConfigApiFp(this.configuration).configSaveDisplayMode(isDarkMode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} calendarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configSaveLastDeviceCalenderIdAndroid(calendarId, options) {
        return ConfigApiFp(this.configuration).configSaveLastDeviceCalenderIdAndroid(calendarId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} calendarId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigApi
     */
    configSaveLastDeviceCalenderIdIos(calendarId, options) {
        return ConfigApiFp(this.configuration).configSaveLastDeviceCalenderIdIos(calendarId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CourseClubApi - axios parameter creator
 * @export
 */
export const CourseClubApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubCheckPersonalDataForCourseBooking: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubCheckPersonalDataForCourseBooking', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseClubCheckPersonalDataForCourseBooking', 'courseId', courseId);
            const localVarPath = `/api/CourseClub/{clubNumber}/CheckPersonalDataForCourseBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (courseId !== undefined) {
                localVarQueryParameter['courseId'] = courseId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCityByCoordinates: (latitude, longitude, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('courseClubGetCityByCoordinates', 'latitude', latitude);
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('courseClubGetCityByCoordinates', 'longitude', longitude);
            const localVarPath = `/api/CourseClub/City`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }
            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourseAdditionalDetails: (clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubGetClubCourseAdditionalDetails', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseClubGetClubCourseAdditionalDetails', 'courseId', courseId);
            const localVarPath = `/api/CourseClub/{clubNumber}/ClubCourseAdditionalDetails/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourseConfig: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubGetClubCourseConfig', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseClub/ClubCourseConfig/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourses: (onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onlyNewCourses' is not null or undefined
            assertParamExists('courseClubGetClubCourses', 'onlyNewCourses', onlyNewCourses);
            // verify required parameter 'maxCourseNumber' is not null or undefined
            assertParamExists('courseClubGetClubCourses', 'maxCourseNumber', maxCourseNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubGetClubCourses', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseClub/ClubCourses/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (onlyNewCourses !== undefined) {
                localVarQueryParameter['onlyNewCourses'] = onlyNewCourses;
            }
            if (maxCourseNumber !== undefined) {
                localVarQueryParameter['maxCourseNumber'] = maxCourseNumber;
            }
            if (freePlacesType !== undefined) {
                localVarQueryParameter['freePlacesType'] = freePlacesType;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCountClubLogins: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/CourseClub/GetCountClubLogins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCourseDetails: (clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubGetCourseDetails', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseClubGetCourseDetails', 'courseId', courseId);
            const localVarPath = `/api/CourseClub/{clubNumber}/CourseDetails/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (onlyFutureMeetings !== undefined) {
                localVarQueryParameter['onlyFutureMeetings'] = onlyFutureMeetings;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCourseMeetings: (clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubGetCourseMeetings', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseClubGetCourseMeetings', 'courseId', courseId);
            const localVarPath = `/api/CourseClub/{clubNumber}/GetCourseMeetings/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            if (onlyFutureMeetings !== undefined) {
                localVarQueryParameter['onlyFutureMeetings'] = onlyFutureMeetings;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetNextCourseMeetings: (maxMeetingNumber, meetingType, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxMeetingNumber' is not null or undefined
            assertParamExists('courseClubGetNextCourseMeetings', 'maxMeetingNumber', maxMeetingNumber);
            // verify required parameter 'meetingType' is not null or undefined
            assertParamExists('courseClubGetNextCourseMeetings', 'meetingType', meetingType);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubGetNextCourseMeetings', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseClub/NextCourseMeetings/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxMeetingNumber !== undefined) {
                localVarQueryParameter['maxMeetingNumber'] = maxMeetingNumber;
            }
            if (meetingType !== undefined) {
                localVarQueryParameter['meetingType'] = meetingType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetPersonalCourses: (meetingType, clubNumber, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'meetingType' is not null or undefined
            assertParamExists('courseClubGetPersonalCourses', 'meetingType', meetingType);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubGetPersonalCourses', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseClub/PersonalCourses/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (meetingType !== undefined) {
                localVarQueryParameter['meetingType'] = meetingType;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubPostSaveCourseBooking: (clubNumber, saveBookingData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubPostSaveCourseBooking', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseClub/{clubNumber}/SaveCourseBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveBookingData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubPostSaveCourseReservation: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubPostSaveCourseReservation', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseClubPostSaveCourseReservation', 'courseId', courseId);
            const localVarPath = `/api/CourseClub/{clubNumber}/SaveCourseReservation/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubRemoveCourseBooking: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubRemoveCourseBooking', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseClubRemoveCourseBooking', 'courseId', courseId);
            const localVarPath = `/api/CourseClub/{clubNumber}/RemoveCourseBooking/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubRemoveCourseReservation: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseClubRemoveCourseReservation', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('courseClubRemoveCourseReservation', 'courseId', courseId);
            const localVarPath = `/api/CourseClub/{clubNumber}/RemoveCourseReservation/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxCourseNumber
         * @param {number} [clubNumber]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {CourseSearchParameter} [searchParameter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubSearchCourses: (maxCourseNumber, clubNumber, imageWidth, imageHeigth, searchParameter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxCourseNumber' is not null or undefined
            assertParamExists('courseClubSearchCourses', 'maxCourseNumber', maxCourseNumber);
            const localVarPath = `/api/CourseClub/SearchCourses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxCourseNumber !== undefined) {
                localVarQueryParameter['maxCourseNumber'] = maxCourseNumber;
            }
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParameter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CourseClubApi - functional programming interface
 * @export
 */
export const CourseClubApiFp = function (configuration) {
    const localVarAxiosParamCreator = CourseClubApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubCheckPersonalDataForCourseBooking(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubCheckPersonalDataForCourseBooking(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCityByCoordinates(latitude, longitude, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetCityByCoordinates(latitude, longitude, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourseConfig(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetClubCourseConfig(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCountClubLogins(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetCountClubLogins(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetNextCourseMeetings(maxMeetingNumber, meetingType, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetNextCourseMeetings(maxMeetingNumber, meetingType, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubPostSaveCourseBooking(clubNumber, saveBookingData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubPostSaveCourseBooking(clubNumber, saveBookingData, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubPostSaveCourseReservation(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubPostSaveCourseReservation(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubRemoveCourseBooking(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubRemoveCourseBooking(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubRemoveCourseReservation(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubRemoveCourseReservation(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxCourseNumber
         * @param {number} [clubNumber]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {CourseSearchParameter} [searchParameter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubSearchCourses(maxCourseNumber, clubNumber, imageWidth, imageHeigth, searchParameter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseClubSearchCourses(maxCourseNumber, clubNumber, imageWidth, imageHeigth, searchParameter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CourseClubApi - factory interface
 * @export
 */
export const CourseClubApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CourseClubApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubCheckPersonalDataForCourseBooking(clubNumber, courseId, options) {
            return localVarFp.courseClubCheckPersonalDataForCourseBooking(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCityByCoordinates(latitude, longitude, options) {
            return localVarFp.courseClubGetCityByCoordinates(latitude, longitude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
            return localVarFp.courseClubGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourseConfig(clubNumber, options) {
            return localVarFp.courseClubGetClubCourseConfig(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
            return localVarFp.courseClubGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCountClubLogins(options) {
            return localVarFp.courseClubGetCountClubLogins(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
            return localVarFp.courseClubGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
            return localVarFp.courseClubGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetNextCourseMeetings(maxMeetingNumber, meetingType, clubNumber, options) {
            return localVarFp.courseClubGetNextCourseMeetings(maxMeetingNumber, meetingType, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
            return localVarFp.courseClubGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubPostSaveCourseBooking(clubNumber, saveBookingData, options) {
            return localVarFp.courseClubPostSaveCourseBooking(clubNumber, saveBookingData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubPostSaveCourseReservation(clubNumber, courseId, options) {
            return localVarFp.courseClubPostSaveCourseReservation(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubRemoveCourseBooking(clubNumber, courseId, options) {
            return localVarFp.courseClubRemoveCourseBooking(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubRemoveCourseReservation(clubNumber, courseId, options) {
            return localVarFp.courseClubRemoveCourseReservation(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxCourseNumber
         * @param {number} [clubNumber]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {CourseSearchParameter} [searchParameter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseClubSearchCourses(maxCourseNumber, clubNumber, imageWidth, imageHeigth, searchParameter, options) {
            return localVarFp.courseClubSearchCourses(maxCourseNumber, clubNumber, imageWidth, imageHeigth, searchParameter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CourseClubApi - object-oriented interface
 * @export
 * @class CourseClubApi
 * @extends {BaseAPI}
 */
export class CourseClubApi extends BaseAPI {
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubCheckPersonalDataForCourseBooking(clubNumber, courseId, options) {
        return CourseClubApiFp(this.configuration).courseClubCheckPersonalDataForCourseBooking(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} latitude
     * @param {number} longitude
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetCityByCoordinates(latitude, longitude, options) {
        return CourseClubApiFp(this.configuration).courseClubGetCityByCoordinates(latitude, longitude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [withClubWithoutLogins]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
        return CourseClubApiFp(this.configuration).courseClubGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetClubCourseConfig(clubNumber, options) {
        return CourseClubApiFp(this.configuration).courseClubGetClubCourseConfig(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} onlyNewCourses
     * @param {number} maxCourseNumber
     * @param {number} clubNumber
     * @param {number} [freePlacesType]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
        return CourseClubApiFp(this.configuration).courseClubGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetCountClubLogins(options) {
        return CourseClubApiFp(this.configuration).courseClubGetCountClubLogins(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [onlyFutureMeetings]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
        return CourseClubApiFp(this.configuration).courseClubGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [withClubWithoutLogins]
     * @param {boolean} [onlyFutureMeetings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
        return CourseClubApiFp(this.configuration).courseClubGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxMeetingNumber
     * @param {number} meetingType
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetNextCourseMeetings(maxMeetingNumber, meetingType, clubNumber, options) {
        return CourseClubApiFp(this.configuration).courseClubGetNextCourseMeetings(maxMeetingNumber, meetingType, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} meetingType
     * @param {number} clubNumber
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
        return CourseClubApiFp(this.configuration).courseClubGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {ClubCourseSaveBookingData} [saveBookingData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubPostSaveCourseBooking(clubNumber, saveBookingData, options) {
        return CourseClubApiFp(this.configuration).courseClubPostSaveCourseBooking(clubNumber, saveBookingData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubPostSaveCourseReservation(clubNumber, courseId, options) {
        return CourseClubApiFp(this.configuration).courseClubPostSaveCourseReservation(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubRemoveCourseBooking(clubNumber, courseId, options) {
        return CourseClubApiFp(this.configuration).courseClubRemoveCourseBooking(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubRemoveCourseReservation(clubNumber, courseId, options) {
        return CourseClubApiFp(this.configuration).courseClubRemoveCourseReservation(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxCourseNumber
     * @param {number} [clubNumber]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {CourseSearchParameter} [searchParameter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseClubApi
     */
    courseClubSearchCourses(maxCourseNumber, clubNumber, imageWidth, imageHeigth, searchParameter, options) {
        return CourseClubApiFp(this.configuration).courseClubSearchCourses(maxCourseNumber, clubNumber, imageWidth, imageHeigth, searchParameter, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CourseInstructorApi - axios parameter creator
 * @export
 */
export const CourseInstructorApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} addressNumber
         * @param {string} feeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorAddToCourse: (clubNumber, id, addressNumber, feeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorAddToCourse', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorAddToCourse', 'id', id);
            // verify required parameter 'addressNumber' is not null or undefined
            assertParamExists('courseInstructorAddToCourse', 'addressNumber', addressNumber);
            // verify required parameter 'feeId' is not null or undefined
            assertParamExists('courseInstructorAddToCourse', 'feeId', feeId);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/members/{addressNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"addressNumber"}}`, encodeURIComponent(String(addressNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (feeId !== undefined) {
                localVarQueryParameter['feeId'] = feeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {ClubAddressMember} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorCreateAddress: (clubNumber, photoWidth, photoHeigth, data, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorCreateAddress', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Addresses`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeigth !== undefined) {
                localVarQueryParameter['photoHeigth'] = photoHeigth;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorDeleteCourseAppointments: (clubNumber, id, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorDeleteCourseAppointments', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorDeleteCourseAppointments', 'id', id);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/appointments`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ids, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {Array<number>} [memberAddressNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorDeleteCourseMembers: (clubNumber, id, memberAddressNumbers, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorDeleteCourseMembers', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorDeleteCourseMembers', 'id', id);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/members`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(memberAddressNumbers, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [birthday]
         * @param {number} [addrNo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetAddress: (clubNumber, firstName, lastName, birthday, addrNo, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetAddress', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Addresses`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }
            if (birthday !== undefined) {
                localVarQueryParameter['birthday'] = (birthday instanceof Date) ?
                    birthday.toISOString() :
                    birthday;
            }
            if (addrNo !== undefined) {
                localVarQueryParameter['addrNo'] = addrNo;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [pastCourses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetAllCourses: (clubNumber, pastCourses, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetAllCourses', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (pastCourses !== undefined) {
                localVarQueryParameter['pastCourses'] = pastCourses;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetClubHasMail: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetClubHasMail', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/ClubMail`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourse: (clubNumber, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetCourse', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorGetCourse', 'id', id);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [onlyDeletable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseAppointments: (clubNumber, id, onlyDeletable, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetCourseAppointments', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorGetCourseAppointments', 'id', id);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/appointments`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (onlyDeletable !== undefined) {
                localVarQueryParameter['onlyDeletable'] = onlyDeletable;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} memberAddressNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseMember: (clubNumber, id, memberAddressNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetCourseMember', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorGetCourseMember', 'id', id);
            // verify required parameter 'memberAddressNumber' is not null or undefined
            assertParamExists('courseInstructorGetCourseMember', 'memberAddressNumber', memberAddressNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/members/{memberAddressNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"memberAddressNumber"}}`, encodeURIComponent(String(memberAddressNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseMembers: (clubNumber, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetCourseMembers', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorGetCourseMembers', 'id', id);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/members`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetHalls: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetHalls', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Halls`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetReceivedPayments: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetReceivedPayments', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Payments`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetRights: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorGetRights', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Rights`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} [maxAppointments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorNextCourseAppointments: (clubNumber, maxAppointments, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorNextCourseAppointments', 'clubNumber', clubNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/NextCourseAppointments`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxAppointments !== undefined) {
                localVarQueryParameter['maxAppointments'] = maxAppointments;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {CourseInstructorCourseAppointment} [appointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorSaveCourseAppointments: (clubNumber, id, appointment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorSaveCourseAppointments', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorSaveCourseAppointments', 'id', id);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/appointment`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(appointment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {MailData} [mailData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorSendMailToMembers: (clubNumber, id, mailData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorSendMailToMembers', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorSendMailToMembers', 'id', id);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/members/mail`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(mailData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} memberAddressNumber
         * @param {CourseMemberDetailsItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorUpdateDivisionMember: (clubNumber, id, memberAddressNumber, data, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('courseInstructorUpdateDivisionMember', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseInstructorUpdateDivisionMember', 'id', id);
            // verify required parameter 'memberAddressNumber' is not null or undefined
            assertParamExists('courseInstructorUpdateDivisionMember', 'memberAddressNumber', memberAddressNumber);
            const localVarPath = `/api/CourseInstructor/{clubNumber}/Courses/{id}/members/{memberAddressNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"memberAddressNumber"}}`, encodeURIComponent(String(memberAddressNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CourseInstructorApi - functional programming interface
 * @export
 */
export const CourseInstructorApiFp = function (configuration) {
    const localVarAxiosParamCreator = CourseInstructorApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} addressNumber
         * @param {string} feeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorAddToCourse(clubNumber, id, addressNumber, feeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorAddToCourse(clubNumber, id, addressNumber, feeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {ClubAddressMember} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorCreateAddress(clubNumber, photoWidth, photoHeigth, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorCreateAddress(clubNumber, photoWidth, photoHeigth, data, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorDeleteCourseAppointments(clubNumber, id, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorDeleteCourseAppointments(clubNumber, id, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {Array<number>} [memberAddressNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorDeleteCourseMembers(clubNumber, id, memberAddressNumbers, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorDeleteCourseMembers(clubNumber, id, memberAddressNumbers, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [birthday]
         * @param {number} [addrNo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetAddress(clubNumber, firstName, lastName, birthday, addrNo, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetAddress(clubNumber, firstName, lastName, birthday, addrNo, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [pastCourses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetAllCourses(clubNumber, pastCourses, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetAllCourses(clubNumber, pastCourses, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetClubHasMail(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetClubHasMail(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourse(clubNumber, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetCourse(clubNumber, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [onlyDeletable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseAppointments(clubNumber, id, onlyDeletable, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetCourseAppointments(clubNumber, id, onlyDeletable, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} memberAddressNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseMember(clubNumber, id, memberAddressNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetCourseMember(clubNumber, id, memberAddressNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseMembers(clubNumber, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetCourseMembers(clubNumber, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetHalls(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetHalls(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetReceivedPayments(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetReceivedPayments(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetRights(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorGetRights(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [maxAppointments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorNextCourseAppointments(clubNumber, maxAppointments, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorNextCourseAppointments(clubNumber, maxAppointments, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {CourseInstructorCourseAppointment} [appointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorSaveCourseAppointments(clubNumber, id, appointment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorSaveCourseAppointments(clubNumber, id, appointment, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {MailData} [mailData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorSendMailToMembers(clubNumber, id, mailData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorSendMailToMembers(clubNumber, id, mailData, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} memberAddressNumber
         * @param {CourseMemberDetailsItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorUpdateDivisionMember(clubNumber, id, memberAddressNumber, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.courseInstructorUpdateDivisionMember(clubNumber, id, memberAddressNumber, data, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CourseInstructorApi - factory interface
 * @export
 */
export const CourseInstructorApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CourseInstructorApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} addressNumber
         * @param {string} feeId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorAddToCourse(clubNumber, id, addressNumber, feeId, options) {
            return localVarFp.courseInstructorAddToCourse(clubNumber, id, addressNumber, feeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {ClubAddressMember} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorCreateAddress(clubNumber, photoWidth, photoHeigth, data, options) {
            return localVarFp.courseInstructorCreateAddress(clubNumber, photoWidth, photoHeigth, data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorDeleteCourseAppointments(clubNumber, id, ids, options) {
            return localVarFp.courseInstructorDeleteCourseAppointments(clubNumber, id, ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {Array<number>} [memberAddressNumbers]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorDeleteCourseMembers(clubNumber, id, memberAddressNumbers, options) {
            return localVarFp.courseInstructorDeleteCourseMembers(clubNumber, id, memberAddressNumbers, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} [firstName]
         * @param {string} [lastName]
         * @param {string} [birthday]
         * @param {number} [addrNo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetAddress(clubNumber, firstName, lastName, birthday, addrNo, options) {
            return localVarFp.courseInstructorGetAddress(clubNumber, firstName, lastName, birthday, addrNo, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [pastCourses]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetAllCourses(clubNumber, pastCourses, options) {
            return localVarFp.courseInstructorGetAllCourses(clubNumber, pastCourses, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetClubHasMail(clubNumber, options) {
            return localVarFp.courseInstructorGetClubHasMail(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourse(clubNumber, id, options) {
            return localVarFp.courseInstructorGetCourse(clubNumber, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [onlyDeletable]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseAppointments(clubNumber, id, onlyDeletable, options) {
            return localVarFp.courseInstructorGetCourseAppointments(clubNumber, id, onlyDeletable, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} memberAddressNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseMember(clubNumber, id, memberAddressNumber, options) {
            return localVarFp.courseInstructorGetCourseMember(clubNumber, id, memberAddressNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetCourseMembers(clubNumber, id, options) {
            return localVarFp.courseInstructorGetCourseMembers(clubNumber, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetHalls(clubNumber, options) {
            return localVarFp.courseInstructorGetHalls(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetReceivedPayments(clubNumber, options) {
            return localVarFp.courseInstructorGetReceivedPayments(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorGetRights(clubNumber, options) {
            return localVarFp.courseInstructorGetRights(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [maxAppointments]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorNextCourseAppointments(clubNumber, maxAppointments, options) {
            return localVarFp.courseInstructorNextCourseAppointments(clubNumber, maxAppointments, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {CourseInstructorCourseAppointment} [appointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorSaveCourseAppointments(clubNumber, id, appointment, options) {
            return localVarFp.courseInstructorSaveCourseAppointments(clubNumber, id, appointment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {MailData} [mailData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorSendMailToMembers(clubNumber, id, mailData, options) {
            return localVarFp.courseInstructorSendMailToMembers(clubNumber, id, mailData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {number} memberAddressNumber
         * @param {CourseMemberDetailsItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseInstructorUpdateDivisionMember(clubNumber, id, memberAddressNumber, data, options) {
            return localVarFp.courseInstructorUpdateDivisionMember(clubNumber, id, memberAddressNumber, data, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CourseInstructorApi - object-oriented interface
 * @export
 * @class CourseInstructorApi
 * @extends {BaseAPI}
 */
export class CourseInstructorApi extends BaseAPI {
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {number} addressNumber
     * @param {string} feeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorAddToCourse(clubNumber, id, addressNumber, feeId, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorAddToCourse(clubNumber, id, addressNumber, feeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} [photoWidth]
     * @param {number} [photoHeigth]
     * @param {ClubAddressMember} [data]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorCreateAddress(clubNumber, photoWidth, photoHeigth, data, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorCreateAddress(clubNumber, photoWidth, photoHeigth, data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorDeleteCourseAppointments(clubNumber, id, ids, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorDeleteCourseAppointments(clubNumber, id, ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {Array<number>} [memberAddressNumbers]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorDeleteCourseMembers(clubNumber, id, memberAddressNumbers, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorDeleteCourseMembers(clubNumber, id, memberAddressNumbers, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} [firstName]
     * @param {string} [lastName]
     * @param {string} [birthday]
     * @param {number} [addrNo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetAddress(clubNumber, firstName, lastName, birthday, addrNo, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetAddress(clubNumber, firstName, lastName, birthday, addrNo, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {boolean} [pastCourses]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetAllCourses(clubNumber, pastCourses, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetAllCourses(clubNumber, pastCourses, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetClubHasMail(clubNumber, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetClubHasMail(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetCourse(clubNumber, id, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetCourse(clubNumber, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {boolean} [onlyDeletable]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetCourseAppointments(clubNumber, id, onlyDeletable, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetCourseAppointments(clubNumber, id, onlyDeletable, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {number} memberAddressNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetCourseMember(clubNumber, id, memberAddressNumber, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetCourseMember(clubNumber, id, memberAddressNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetCourseMembers(clubNumber, id, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetCourseMembers(clubNumber, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetHalls(clubNumber, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetHalls(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetReceivedPayments(clubNumber, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetReceivedPayments(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorGetRights(clubNumber, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorGetRights(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} [maxAppointments]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorNextCourseAppointments(clubNumber, maxAppointments, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorNextCourseAppointments(clubNumber, maxAppointments, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {CourseInstructorCourseAppointment} [appointment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorSaveCourseAppointments(clubNumber, id, appointment, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorSaveCourseAppointments(clubNumber, id, appointment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {MailData} [mailData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorSendMailToMembers(clubNumber, id, mailData, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorSendMailToMembers(clubNumber, id, mailData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {number} memberAddressNumber
     * @param {CourseMemberDetailsItem} [data]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CourseInstructorApi
     */
    courseInstructorUpdateDivisionMember(clubNumber, id, memberAddressNumber, data, options) {
        return CourseInstructorApiFp(this.configuration).courseInstructorUpdateDivisionMember(clubNumber, id, memberAddressNumber, data, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExerciseInstructorApi - axios parameter creator
 * @export
 */
export const ExerciseInstructorApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {ExerciseInstructorHoursItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorAddHours: (clubNumber, data, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorAddHours', 'clubNumber', clubNumber);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Hours`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorDeleteHours: (clubNumber, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorDeleteHours', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exerciseInstructorDeleteHours', 'id', id);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Hours/{id}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivision: (clubNumber, divisionNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivision', 'clubNumber', clubNumber);
            // verify required parameter 'divisionNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivision', 'divisionNumber', divisionNumber);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Divisions/{divisionNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"divisionNumber"}}`, encodeURIComponent(String(divisionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {number} memberAdressNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisionMember: (clubNumber, divisionNumber, memberAdressNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivisionMember', 'clubNumber', clubNumber);
            // verify required parameter 'divisionNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivisionMember', 'divisionNumber', divisionNumber);
            // verify required parameter 'memberAdressNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivisionMember', 'memberAdressNumber', memberAdressNumber);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Divisions/{divisionNumber}/Members/{memberAdressNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"divisionNumber"}}`, encodeURIComponent(String(divisionNumber)))
                .replace(`{${"memberAdressNumber"}}`, encodeURIComponent(String(memberAdressNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisionMembers: (clubNumber, divisionNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivisionMembers', 'clubNumber', clubNumber);
            // verify required parameter 'divisionNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivisionMembers', 'divisionNumber', divisionNumber);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Divisions/{divisionNumber}/Members`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"divisionNumber"}}`, encodeURIComponent(String(divisionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisions: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetDivisions', 'clubNumber', clubNumber);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Divisions`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetHours: (clubNumber, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetHours', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exerciseInstructorGetHours', 'id', id);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Hours/{id}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetHoursAll: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorGetHoursAll', 'clubNumber', clubNumber);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Hours`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {number} memberAdressNumber
         * @param {DivisionMemberDetailsItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorUpdateDivisionMember: (clubNumber, divisionNumber, memberAdressNumber, data, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorUpdateDivisionMember', 'clubNumber', clubNumber);
            // verify required parameter 'divisionNumber' is not null or undefined
            assertParamExists('exerciseInstructorUpdateDivisionMember', 'divisionNumber', divisionNumber);
            // verify required parameter 'memberAdressNumber' is not null or undefined
            assertParamExists('exerciseInstructorUpdateDivisionMember', 'memberAdressNumber', memberAdressNumber);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Divisions/{divisionNumber}/Members/{memberAdressNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"divisionNumber"}}`, encodeURIComponent(String(divisionNumber)))
                .replace(`{${"memberAdressNumber"}}`, encodeURIComponent(String(memberAdressNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {ExerciseInstructorHoursItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorUpdateHours: (clubNumber, id, data, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('exerciseInstructorUpdateHours', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exerciseInstructorUpdateHours', 'id', id);
            const localVarPath = `/api/ExerciseInstructor/{clubNumber}/Hours/{id}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ExerciseInstructorApi - functional programming interface
 * @export
 */
export const ExerciseInstructorApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExerciseInstructorApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {ExerciseInstructorHoursItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorAddHours(clubNumber, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorAddHours(clubNumber, data, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorDeleteHours(clubNumber, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorDeleteHours(clubNumber, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivision(clubNumber, divisionNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorGetDivision(clubNumber, divisionNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {number} memberAdressNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisionMember(clubNumber, divisionNumber, memberAdressNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorGetDivisionMember(clubNumber, divisionNumber, memberAdressNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisionMembers(clubNumber, divisionNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorGetDivisionMembers(clubNumber, divisionNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisions(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorGetDivisions(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetHours(clubNumber, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorGetHours(clubNumber, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetHoursAll(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorGetHoursAll(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {number} memberAdressNumber
         * @param {DivisionMemberDetailsItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorUpdateDivisionMember(clubNumber, divisionNumber, memberAdressNumber, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorUpdateDivisionMember(clubNumber, divisionNumber, memberAdressNumber, data, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {ExerciseInstructorHoursItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorUpdateHours(clubNumber, id, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exerciseInstructorUpdateHours(clubNumber, id, data, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ExerciseInstructorApi - factory interface
 * @export
 */
export const ExerciseInstructorApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExerciseInstructorApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {ExerciseInstructorHoursItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorAddHours(clubNumber, data, options) {
            return localVarFp.exerciseInstructorAddHours(clubNumber, data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorDeleteHours(clubNumber, id, options) {
            return localVarFp.exerciseInstructorDeleteHours(clubNumber, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivision(clubNumber, divisionNumber, options) {
            return localVarFp.exerciseInstructorGetDivision(clubNumber, divisionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {number} memberAdressNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisionMember(clubNumber, divisionNumber, memberAdressNumber, options) {
            return localVarFp.exerciseInstructorGetDivisionMember(clubNumber, divisionNumber, memberAdressNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisionMembers(clubNumber, divisionNumber, options) {
            return localVarFp.exerciseInstructorGetDivisionMembers(clubNumber, divisionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetDivisions(clubNumber, options) {
            return localVarFp.exerciseInstructorGetDivisions(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetHours(clubNumber, id, options) {
            return localVarFp.exerciseInstructorGetHours(clubNumber, id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorGetHoursAll(clubNumber, options) {
            return localVarFp.exerciseInstructorGetHoursAll(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} divisionNumber
         * @param {number} memberAdressNumber
         * @param {DivisionMemberDetailsItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorUpdateDivisionMember(clubNumber, divisionNumber, memberAdressNumber, data, options) {
            return localVarFp.exerciseInstructorUpdateDivisionMember(clubNumber, divisionNumber, memberAdressNumber, data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} id
         * @param {ExerciseInstructorHoursItem} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exerciseInstructorUpdateHours(clubNumber, id, data, options) {
            return localVarFp.exerciseInstructorUpdateHours(clubNumber, id, data, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExerciseInstructorApi - object-oriented interface
 * @export
 * @class ExerciseInstructorApi
 * @extends {BaseAPI}
 */
export class ExerciseInstructorApi extends BaseAPI {
    /**
     *
     * @param {number} clubNumber
     * @param {ExerciseInstructorHoursItem} [data]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorAddHours(clubNumber, data, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorAddHours(clubNumber, data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorDeleteHours(clubNumber, id, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorDeleteHours(clubNumber, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} divisionNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorGetDivision(clubNumber, divisionNumber, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorGetDivision(clubNumber, divisionNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} divisionNumber
     * @param {number} memberAdressNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorGetDivisionMember(clubNumber, divisionNumber, memberAdressNumber, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorGetDivisionMember(clubNumber, divisionNumber, memberAdressNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} divisionNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorGetDivisionMembers(clubNumber, divisionNumber, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorGetDivisionMembers(clubNumber, divisionNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorGetDivisions(clubNumber, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorGetDivisions(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorGetHours(clubNumber, id, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorGetHours(clubNumber, id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorGetHoursAll(clubNumber, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorGetHoursAll(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} divisionNumber
     * @param {number} memberAdressNumber
     * @param {DivisionMemberDetailsItem} [data]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorUpdateDivisionMember(clubNumber, divisionNumber, memberAdressNumber, data, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorUpdateDivisionMember(clubNumber, divisionNumber, memberAdressNumber, data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} id
     * @param {ExerciseInstructorHoursItem} [data]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExerciseInstructorApi
     */
    exerciseInstructorUpdateHours(clubNumber, id, data, options) {
        return ExerciseInstructorApiFp(this.configuration).exerciseInstructorUpdateHours(clubNumber, id, data, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HaKuBuApi - axios parameter creator
 * @export
 */
export const HaKuBuApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCalculateHallRent: (clubNumber, hallId, date, from, to, fullTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'clubNumber', clubNumber);
            // verify required parameter 'hallId' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'hallId', hallId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'date', date);
            // verify required parameter 'from' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'to', to);
            // verify required parameter 'fullTime' is not null or undefined
            assertParamExists('haKuBuCalculateHallRent', 'fullTime', fullTime);
            const localVarPath = `/api/HaKuBu/{clubNumber}/CalculateHallRent`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (hallId !== undefined) {
                localVarQueryParameter['hallId'] = hallId;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (fullTime !== undefined) {
                localVarQueryParameter['fullTime'] = fullTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCapturePaypalOrder: (clubNumber, captureOrderInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCapturePaypalOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/Paypal/CaptureOrder/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(captureOrderInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCheckPersonalDataForHallBooking: (clubNumber, hallId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCheckPersonalDataForHallBooking', 'clubNumber', clubNumber);
            // verify required parameter 'hallId' is not null or undefined
            assertParamExists('haKuBuCheckPersonalDataForHallBooking', 'hallId', hallId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/CheckPersonalDataForHallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (hallId !== undefined) {
                localVarQueryParameter['hallId'] = hallId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCreatePaypalOrder: (clubNumber, createOrderInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuCreatePaypalOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/Paypal/CreateOrder/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuDeleteHallBookings: (clubNumber, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuDeleteHallBookings', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/HallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ids, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseAdditionalDetails: (clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourseAdditionalDetails', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuGetClubCourseAdditionalDetails', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/ClubCourseAdditionalDetails/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseConfig: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourseConfig', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/ClubCourseConfig/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourses: (onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'onlyNewCourses' is not null or undefined
            assertParamExists('haKuBuGetClubCourses', 'onlyNewCourses', onlyNewCourses);
            // verify required parameter 'maxCourseNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourses', 'maxCourseNumber', maxCourseNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubCourses', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/ClubCourses/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (onlyNewCourses !== undefined) {
                localVarQueryParameter['onlyNewCourses'] = onlyNewCourses;
            }
            if (maxCourseNumber !== undefined) {
                localVarQueryParameter['maxCourseNumber'] = maxCourseNumber;
            }
            if (freePlacesType !== undefined) {
                localVarQueryParameter['freePlacesType'] = freePlacesType;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubData: (logoWidth, logoHeigth, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'logoWidth' is not null or undefined
            assertParamExists('haKuBuGetClubData', 'logoWidth', logoWidth);
            // verify required parameter 'logoHeigth' is not null or undefined
            assertParamExists('haKuBuGetClubData', 'logoHeigth', logoHeigth);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetClubData', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/GetClubData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetConfig: (vereinsNummer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vereinsNummer' is not null or undefined
            assertParamExists('haKuBuGetConfig', 'vereinsNummer', vereinsNummer);
            const localVarPath = `/api/HaKuBu/GetConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (vereinsNummer !== undefined) {
                localVarQueryParameter['vereinsNummer'] = vereinsNummer;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseDetails: (clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetCourseDetails', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuGetCourseDetails', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/CourseDetails/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (onlyFutureMeetings !== undefined) {
                localVarQueryParameter['onlyFutureMeetings'] = onlyFutureMeetings;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseMeetings: (clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetCourseMeetings', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuGetCourseMeetings', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/GetCourseMeetings/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            if (onlyFutureMeetings !== undefined) {
                localVarQueryParameter['onlyFutureMeetings'] = onlyFutureMeetings;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetFreeDates: (clubNumber, id, date, from, to, duration, fullTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetFreeDates', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('haKuBuGetFreeDates', 'id', id);
            // verify required parameter 'date' is not null or undefined
            assertParamExists('haKuBuGetFreeDates', 'date', date);
            const localVarPath = `/api/HaKuBu/{clubNumber}/{id}/FreeDates`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }
            if (fullTime !== undefined) {
                localVarQueryParameter['fullTime'] = fullTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHallDetails: (clubNumber, id, withClubWithoutLogins, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetHallDetails', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('haKuBuGetHallDetails', 'id', id);
            const localVarPath = `/api/HaKuBu/{clubNumber}/{id}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHalls: (maxHallNumber, clubNumber, bookings, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxHallNumber' is not null or undefined
            assertParamExists('haKuBuGetHalls', 'maxHallNumber', maxHallNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetHalls', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxHallNumber !== undefined) {
                localVarQueryParameter['maxHallNumber'] = maxHallNumber;
            }
            if (bookings !== undefined) {
                localVarQueryParameter['bookings'] = bookings;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetNextHallMeetings: (maxMeetingNumber, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxMeetingNumber' is not null or undefined
            assertParamExists('haKuBuGetNextHallMeetings', 'maxMeetingNumber', maxMeetingNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetNextHallMeetings', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/NextHallMeetings`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxMeetingNumber !== undefined) {
                localVarQueryParameter['maxMeetingNumber'] = maxMeetingNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPaymentOptions: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetPaymentOptions', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/PaymentOptions/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} adressNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPermissions: (clubNumber, adressNummer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetPermissions', 'clubNumber', clubNumber);
            // verify required parameter 'adressNummer' is not null or undefined
            assertParamExists('haKuBuGetPermissions', 'adressNummer', adressNummer);
            const localVarPath = `/api/HaKuBu/GetPermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            if (adressNummer !== undefined) {
                localVarQueryParameter['adressNummer'] = adressNummer;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPersonalCourses: (meetingType, clubNumber, imageWidth, imageHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'meetingType' is not null or undefined
            assertParamExists('haKuBuGetPersonalCourses', 'meetingType', meetingType);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuGetPersonalCourses', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/PersonalCourses/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (meetingType !== undefined) {
                localVarQueryParameter['meetingType'] = meetingType;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuHallBooking: (clubNumber, hallAppointment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuHallBooking', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/HallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(hallAppointment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuLoadPersonalData: (clubNumber, withPhoto, photoWidth, photoHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuLoadPersonalData', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/PersonalData`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withPhoto !== undefined) {
                localVarQueryParameter['withPhoto'] = withPhoto;
            }
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeigth !== undefined) {
                localVarQueryParameter['photoHeigth'] = photoHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPersonenLogin: (personenLogin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/HaKuBu/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(personenLogin, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseBooking: (clubNumber, saveBookingData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuPostSaveCourseBooking', 'clubNumber', clubNumber);
            const localVarPath = `/api/HaKuBu/{clubNumber}/SaveCourseBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveBookingData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseReservation: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuPostSaveCourseReservation', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuPostSaveCourseReservation', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/SaveCourseReservation/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseBooking: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuRemoveCourseBooking', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuRemoveCourseBooking', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/RemoveCourseBooking/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseReservation: (clubNumber, courseId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('haKuBuRemoveCourseReservation', 'clubNumber', clubNumber);
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('haKuBuRemoveCourseReservation', 'courseId', courseId);
            const localVarPath = `/api/HaKuBu/{clubNumber}/RemoveCourseReservation/{courseId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"courseId"}}`, encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuVereinsLogin: (vereinsLogin, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/HaKuBu/VereinsLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(vereinsLogin, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * HaKuBuApi - functional programming interface
 * @export
 */
export const HaKuBuApiFp = function (configuration) {
    const localVarAxiosParamCreator = HaKuBuApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuDeleteHallBookings(clubNumber, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuDeleteHallBookings(clubNumber, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseConfig(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubCourseConfig(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetConfig(vereinsNummer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetConfig(vereinsNummer, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPaymentOptions(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetPaymentOptions(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} adressNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPermissions(clubNumber, adressNummer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetPermissions(clubNumber, adressNummer, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuHallBooking(clubNumber, hallAppointment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuHallBooking(clubNumber, hallAppointment, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPersonenLogin(personenLogin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuPersonenLogin(personenLogin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseReservation(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuPostSaveCourseReservation(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseBooking(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuRemoveCourseBooking(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseReservation(clubNumber, courseId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuRemoveCourseReservation(clubNumber, courseId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuVereinsLogin(vereinsLogin, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.haKuBuVereinsLogin(vereinsLogin, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * HaKuBuApi - factory interface
 * @export
 */
export const HaKuBuApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HaKuBuApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
            return localVarFp.haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options) {
            return localVarFp.haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
            return localVarFp.haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options) {
            return localVarFp.haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuDeleteHallBookings(clubNumber, ids, options) {
            return localVarFp.haKuBuDeleteHallBookings(clubNumber, ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourseConfig(clubNumber, options) {
            return localVarFp.haKuBuGetClubCourseConfig(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} onlyNewCourses
         * @param {number} maxCourseNumber
         * @param {number} clubNumber
         * @param {number} [freePlacesType]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return localVarFp.haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetConfig(vereinsNummer, options) {
            return localVarFp.haKuBuGetConfig(vereinsNummer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [onlyFutureMeetings]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {boolean} [withClubWithoutLogins]
         * @param {boolean} [onlyFutureMeetings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
            return localVarFp.haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
            return localVarFp.haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
            return localVarFp.haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options) {
            return localVarFp.haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
            return localVarFp.haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPaymentOptions(clubNumber, options) {
            return localVarFp.haKuBuGetPaymentOptions(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} adressNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPermissions(clubNumber, adressNummer, options) {
            return localVarFp.haKuBuGetPermissions(clubNumber, adressNummer, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} meetingType
         * @param {number} clubNumber
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
            return localVarFp.haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuHallBooking(clubNumber, hallAppointment, options) {
            return localVarFp.haKuBuHallBooking(clubNumber, hallAppointment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
            return localVarFp.haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PersonenLoginViewModel} [personenLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPersonenLogin(personenLogin, options) {
            return localVarFp.haKuBuPersonenLogin(personenLogin, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {ClubCourseSaveBookingData} [saveBookingData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options) {
            return localVarFp.haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuPostSaveCourseReservation(clubNumber, courseId, options) {
            return localVarFp.haKuBuPostSaveCourseReservation(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseBooking(clubNumber, courseId, options) {
            return localVarFp.haKuBuRemoveCourseBooking(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} courseId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuRemoveCourseReservation(clubNumber, courseId, options) {
            return localVarFp.haKuBuRemoveCourseReservation(clubNumber, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {VereinsLoginViewModel} [vereinsLogin]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        haKuBuVereinsLogin(vereinsLogin, options) {
            return localVarFp.haKuBuVereinsLogin(vereinsLogin, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HaKuBuApi - object-oriented interface
 * @export
 * @class HaKuBuApi
 * @extends {BaseAPI}
 */
export class HaKuBuApi extends BaseAPI {
    /**
     *
     * @param {number} clubNumber
     * @param {string} hallId
     * @param {string} date
     * @param {string} from
     * @param {string} to
     * @param {boolean} fullTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {PayPalCaptureOrderInput} [captureOrderInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCapturePaypalOrder(clubNumber, captureOrderInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} hallId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCheckPersonalDataForHallBooking(clubNumber, hallId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {PayPalCreateOrderInput} [createOrderInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options) {
        return HaKuBuApiFp(this.configuration).haKuBuCreatePaypalOrder(clubNumber, createOrderInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuDeleteHallBookings(clubNumber, ids, options) {
        return HaKuBuApiFp(this.configuration).haKuBuDeleteHallBookings(clubNumber, ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [withClubWithoutLogins]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubCourseAdditionalDetails(clubNumber, courseId, withClubWithoutLogins, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubCourseConfig(clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubCourseConfig(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} onlyNewCourses
     * @param {number} maxCourseNumber
     * @param {number} clubNumber
     * @param {number} [freePlacesType]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubCourses(onlyNewCourses, maxCourseNumber, clubNumber, freePlacesType, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} logoWidth
     * @param {number} logoHeigth
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} vereinsNummer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetConfig(vereinsNummer, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetConfig(vereinsNummer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [onlyFutureMeetings]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetCourseDetails(clubNumber, courseId, onlyFutureMeetings, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {boolean} [withClubWithoutLogins]
     * @param {boolean} [onlyFutureMeetings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetCourseMeetings(clubNumber, courseId, withClubWithoutLogins, onlyFutureMeetings, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {string} date
     * @param {string} [from]
     * @param {string} [to]
     * @param {number} [duration]
     * @param {boolean} [fullTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {boolean} [withClubWithoutLogins]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetHallDetails(clubNumber, id, withClubWithoutLogins, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxHallNumber
     * @param {number} clubNumber
     * @param {number} [bookings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetHalls(maxHallNumber, clubNumber, bookings, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxMeetingNumber
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetNextHallMeetings(maxMeetingNumber, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetPaymentOptions(clubNumber, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetPaymentOptions(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} adressNummer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetPermissions(clubNumber, adressNummer, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetPermissions(clubNumber, adressNummer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} meetingType
     * @param {number} clubNumber
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuGetPersonalCourses(meetingType, clubNumber, imageWidth, imageHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {HallAppointment} [hallAppointment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuHallBooking(clubNumber, hallAppointment, options) {
        return HaKuBuApiFp(this.configuration).haKuBuHallBooking(clubNumber, hallAppointment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {boolean} [withPhoto]
     * @param {number} [photoWidth]
     * @param {number} [photoHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
        return HaKuBuApiFp(this.configuration).haKuBuLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {PersonenLoginViewModel} [personenLogin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuPersonenLogin(personenLogin, options) {
        return HaKuBuApiFp(this.configuration).haKuBuPersonenLogin(personenLogin, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {ClubCourseSaveBookingData} [saveBookingData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options) {
        return HaKuBuApiFp(this.configuration).haKuBuPostSaveCourseBooking(clubNumber, saveBookingData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuPostSaveCourseReservation(clubNumber, courseId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuPostSaveCourseReservation(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuRemoveCourseBooking(clubNumber, courseId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuRemoveCourseBooking(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} courseId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuRemoveCourseReservation(clubNumber, courseId, options) {
        return HaKuBuApiFp(this.configuration).haKuBuRemoveCourseReservation(clubNumber, courseId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {VereinsLoginViewModel} [vereinsLogin]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HaKuBuApi
     */
    haKuBuVereinsLogin(vereinsLogin, options) {
        return HaKuBuApiFp(this.configuration).haKuBuVereinsLogin(vereinsLogin, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * HallsApi - axios parameter creator
 * @export
 */
export const HallsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsCalculateHallRent: (clubNumber, hallId, date, from, to, fullTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsCalculateHallRent', 'clubNumber', clubNumber);
            // verify required parameter 'hallId' is not null or undefined
            assertParamExists('hallsCalculateHallRent', 'hallId', hallId);
            // verify required parameter 'date' is not null or undefined
            assertParamExists('hallsCalculateHallRent', 'date', date);
            // verify required parameter 'from' is not null or undefined
            assertParamExists('hallsCalculateHallRent', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('hallsCalculateHallRent', 'to', to);
            // verify required parameter 'fullTime' is not null or undefined
            assertParamExists('hallsCalculateHallRent', 'fullTime', fullTime);
            const localVarPath = `/api/Halls/{clubNumber}/CalculateHallRent`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (hallId !== undefined) {
                localVarQueryParameter['hallId'] = hallId;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (fullTime !== undefined) {
                localVarQueryParameter['fullTime'] = fullTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsCheckPersonalDataForHallBooking: (clubNumber, hallId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsCheckPersonalDataForHallBooking', 'clubNumber', clubNumber);
            // verify required parameter 'hallId' is not null or undefined
            assertParamExists('hallsCheckPersonalDataForHallBooking', 'hallId', hallId);
            const localVarPath = `/api/Halls/{clubNumber}/CheckPersonalDataForHallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (hallId !== undefined) {
                localVarQueryParameter['hallId'] = hallId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsDeleteHallBookings: (clubNumber, ids, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsDeleteHallBookings', 'clubNumber', clubNumber);
            const localVarPath = `/api/Halls/{clubNumber}/HallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ids, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetAllHallsForSelection: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsGetAllHallsForSelection', 'clubNumber', clubNumber);
            const localVarPath = `/api/Halls/{clubNumber}/GetAllHallsForSelection`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetCityByCoordinates: (latitude, longitude, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('hallsGetCityByCoordinates', 'latitude', latitude);
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('hallsGetCityByCoordinates', 'longitude', longitude);
            const localVarPath = `/api/Halls/City`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }
            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetFreeDates: (clubNumber, id, date, from, to, duration, fullTime, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsGetFreeDates', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hallsGetFreeDates', 'id', id);
            // verify required parameter 'date' is not null or undefined
            assertParamExists('hallsGetFreeDates', 'date', date);
            const localVarPath = `/api/Halls/{clubNumber}/{id}/FreeDates`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }
            if (fullTime !== undefined) {
                localVarQueryParameter['fullTime'] = fullTime;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallBookingParameters: (clubNumber, hallId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsGetHallBookingParameters', 'clubNumber', clubNumber);
            // verify required parameter 'hallId' is not null or undefined
            assertParamExists('hallsGetHallBookingParameters', 'hallId', hallId);
            const localVarPath = `/api/Halls/{clubNumber}/HallBookingParameters/{hallId}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"hallId"}}`, encodeURIComponent(String(hallId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallDetails: (clubNumber, id, withClubWithoutLogins, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsGetHallDetails', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hallsGetHallDetails', 'id', id);
            const localVarPath = `/api/Halls/{clubNumber}/{id}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withClubWithoutLogins !== undefined) {
                localVarQueryParameter['withClubWithoutLogins'] = withClubWithoutLogins;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} from
         * @param {string} to
         * @param {boolean} [fillEmptyDays]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallEvents: (clubNumber, id, from, to, fillEmptyDays, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsGetHallEvents', 'clubNumber', clubNumber);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('hallsGetHallEvents', 'id', id);
            // verify required parameter 'from' is not null or undefined
            assertParamExists('hallsGetHallEvents', 'from', from);
            // verify required parameter 'to' is not null or undefined
            assertParamExists('hallsGetHallEvents', 'to', to);
            const localVarPath = `/api/Halls/{clubNumber}/{id}/Events`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (fillEmptyDays !== undefined) {
                localVarQueryParameter['fillEmptyDays'] = fillEmptyDays;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHalls: (maxHallNumber, clubNumber, bookings, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxHallNumber' is not null or undefined
            assertParamExists('hallsGetHalls', 'maxHallNumber', maxHallNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsGetHalls', 'clubNumber', clubNumber);
            const localVarPath = `/api/Halls/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxHallNumber !== undefined) {
                localVarQueryParameter['maxHallNumber'] = maxHallNumber;
            }
            if (bookings !== undefined) {
                localVarQueryParameter['bookings'] = bookings;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetNextHallMeetings: (maxMeetingNumber, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'maxMeetingNumber' is not null or undefined
            assertParamExists('hallsGetNextHallMeetings', 'maxMeetingNumber', maxMeetingNumber);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsGetNextHallMeetings', 'clubNumber', clubNumber);
            const localVarPath = `/api/Halls/{clubNumber}/NextHallMeetings`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (maxMeetingNumber !== undefined) {
                localVarQueryParameter['maxMeetingNumber'] = maxMeetingNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsHallBooking: (clubNumber, hallAppointment, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('hallsHallBooking', 'clubNumber', clubNumber);
            const localVarPath = `/api/Halls/{clubNumber}/HallBooking`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(hallAppointment, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [clubNumber]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {HallSearchParameter} [searchParameter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsSearchHalls: (clubNumber, imageWidth, imageHeigth, searchParameter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/Halls/SearchHalls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            if (imageWidth !== undefined) {
                localVarQueryParameter['imageWidth'] = imageWidth;
            }
            if (imageHeigth !== undefined) {
                localVarQueryParameter['imageHeigth'] = imageHeigth;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchParameter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * HallsApi - functional programming interface
 * @export
 */
export const HallsApiFp = function (configuration) {
    const localVarAxiosParamCreator = HallsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsCheckPersonalDataForHallBooking(clubNumber, hallId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsDeleteHallBookings(clubNumber, ids, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsDeleteHallBookings(clubNumber, ids, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetAllHallsForSelection(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetAllHallsForSelection(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetCityByCoordinates(latitude, longitude, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetCityByCoordinates(latitude, longitude, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallBookingParameters(clubNumber, hallId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetHallBookingParameters(clubNumber, hallId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetHallDetails(clubNumber, id, withClubWithoutLogins, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} from
         * @param {string} to
         * @param {boolean} [fillEmptyDays]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallEvents(clubNumber, id, from, to, fillEmptyDays, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetHallEvents(clubNumber, id, from, to, fillEmptyDays, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHalls(maxHallNumber, clubNumber, bookings, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetHalls(maxHallNumber, clubNumber, bookings, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsGetNextHallMeetings(maxMeetingNumber, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsHallBooking(clubNumber, hallAppointment, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsHallBooking(clubNumber, hallAppointment, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [clubNumber]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {HallSearchParameter} [searchParameter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsSearchHalls(clubNumber, imageWidth, imageHeigth, searchParameter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.hallsSearchHalls(clubNumber, imageWidth, imageHeigth, searchParameter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * HallsApi - factory interface
 * @export
 */
export const HallsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = HallsApiFp(configuration);
    return {
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {string} date
         * @param {string} from
         * @param {string} to
         * @param {boolean} fullTime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
            return localVarFp.hallsCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
            return localVarFp.hallsCheckPersonalDataForHallBooking(clubNumber, hallId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {Array<string>} [ids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsDeleteHallBookings(clubNumber, ids, options) {
            return localVarFp.hallsDeleteHallBookings(clubNumber, ids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetAllHallsForSelection(clubNumber, options) {
            return localVarFp.hallsGetAllHallsForSelection(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetCityByCoordinates(latitude, longitude, options) {
            return localVarFp.hallsGetCityByCoordinates(latitude, longitude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} date
         * @param {string} [from]
         * @param {string} [to]
         * @param {number} [duration]
         * @param {boolean} [fullTime]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
            return localVarFp.hallsGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} hallId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallBookingParameters(clubNumber, hallId, options) {
            return localVarFp.hallsGetHallBookingParameters(clubNumber, hallId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {boolean} [withClubWithoutLogins]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
            return localVarFp.hallsGetHallDetails(clubNumber, id, withClubWithoutLogins, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {string} id
         * @param {string} from
         * @param {string} to
         * @param {boolean} [fillEmptyDays]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHallEvents(clubNumber, id, from, to, fillEmptyDays, options) {
            return localVarFp.hallsGetHallEvents(clubNumber, id, from, to, fillEmptyDays, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxHallNumber
         * @param {number} clubNumber
         * @param {number} [bookings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetHalls(maxHallNumber, clubNumber, bookings, options) {
            return localVarFp.hallsGetHalls(maxHallNumber, clubNumber, bookings, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} maxMeetingNumber
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
            return localVarFp.hallsGetNextHallMeetings(maxMeetingNumber, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {HallAppointment} [hallAppointment]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsHallBooking(clubNumber, hallAppointment, options) {
            return localVarFp.hallsHallBooking(clubNumber, hallAppointment, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [clubNumber]
         * @param {number} [imageWidth]
         * @param {number} [imageHeigth]
         * @param {HallSearchParameter} [searchParameter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hallsSearchHalls(clubNumber, imageWidth, imageHeigth, searchParameter, options) {
            return localVarFp.hallsSearchHalls(clubNumber, imageWidth, imageHeigth, searchParameter, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * HallsApi - object-oriented interface
 * @export
 * @class HallsApi
 * @extends {BaseAPI}
 */
export class HallsApi extends BaseAPI {
    /**
     *
     * @param {number} clubNumber
     * @param {string} hallId
     * @param {string} date
     * @param {string} from
     * @param {string} to
     * @param {boolean} fullTime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options) {
        return HallsApiFp(this.configuration).hallsCalculateHallRent(clubNumber, hallId, date, from, to, fullTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} hallId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsCheckPersonalDataForHallBooking(clubNumber, hallId, options) {
        return HallsApiFp(this.configuration).hallsCheckPersonalDataForHallBooking(clubNumber, hallId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {Array<string>} [ids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsDeleteHallBookings(clubNumber, ids, options) {
        return HallsApiFp(this.configuration).hallsDeleteHallBookings(clubNumber, ids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetAllHallsForSelection(clubNumber, options) {
        return HallsApiFp(this.configuration).hallsGetAllHallsForSelection(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} latitude
     * @param {number} longitude
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetCityByCoordinates(latitude, longitude, options) {
        return HallsApiFp(this.configuration).hallsGetCityByCoordinates(latitude, longitude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {string} date
     * @param {string} [from]
     * @param {string} [to]
     * @param {number} [duration]
     * @param {boolean} [fullTime]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options) {
        return HallsApiFp(this.configuration).hallsGetFreeDates(clubNumber, id, date, from, to, duration, fullTime, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} hallId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetHallBookingParameters(clubNumber, hallId, options) {
        return HallsApiFp(this.configuration).hallsGetHallBookingParameters(clubNumber, hallId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {boolean} [withClubWithoutLogins]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetHallDetails(clubNumber, id, withClubWithoutLogins, options) {
        return HallsApiFp(this.configuration).hallsGetHallDetails(clubNumber, id, withClubWithoutLogins, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {string} id
     * @param {string} from
     * @param {string} to
     * @param {boolean} [fillEmptyDays]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetHallEvents(clubNumber, id, from, to, fillEmptyDays, options) {
        return HallsApiFp(this.configuration).hallsGetHallEvents(clubNumber, id, from, to, fillEmptyDays, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxHallNumber
     * @param {number} clubNumber
     * @param {number} [bookings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetHalls(maxHallNumber, clubNumber, bookings, options) {
        return HallsApiFp(this.configuration).hallsGetHalls(maxHallNumber, clubNumber, bookings, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} maxMeetingNumber
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsGetNextHallMeetings(maxMeetingNumber, clubNumber, options) {
        return HallsApiFp(this.configuration).hallsGetNextHallMeetings(maxMeetingNumber, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {HallAppointment} [hallAppointment]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsHallBooking(clubNumber, hallAppointment, options) {
        return HallsApiFp(this.configuration).hallsHallBooking(clubNumber, hallAppointment, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [clubNumber]
     * @param {number} [imageWidth]
     * @param {number} [imageHeigth]
     * @param {HallSearchParameter} [searchParameter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HallsApi
     */
    hallsSearchHalls(clubNumber, imageWidth, imageHeigth, searchParameter, options) {
        return HallsApiFp(this.configuration).hallsSearchHalls(clubNumber, imageWidth, imageHeigth, searchParameter, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * LoginApi - axios parameter creator
 * @export
 */
export const LoginApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogin: (account, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/Login/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(account, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function (configuration) {
    const localVarAxiosParamCreator = LoginApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogin(account, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginLogin(account, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LoginApiFp(configuration);
    return {
        /**
         *
         * @param {AppLoginViewModel} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLogin(account, options) {
            return localVarFp.loginLogin(account, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
    /**
     *
     * @param {AppLoginViewModel} [account]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoginApi
     */
    loginLogin(account, options) {
        return LoginApiFp(this.configuration).loginLogin(account, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * NewMembershipApi - axios parameter creator
 * @export
 */
export const NewMembershipApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} id
         * @param {number} clubNum
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipConfirmAddressRegistration: (id, clubNum, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('newMembershipConfirmAddressRegistration', 'id', id);
            // verify required parameter 'clubNum' is not null or undefined
            assertParamExists('newMembershipConfirmAddressRegistration', 'clubNum', clubNum);
            const localVarPath = `/api/NewMembership/ConfirmAddressRegistration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (clubNum !== undefined) {
                localVarQueryParameter['clubNum'] = clubNum;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {boolean} [withDuplicateCheck]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {ClubAddressMember} [personalData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipCreateNewClubMembership: (withDuplicateCheck, photoWidth, photoHeigth, personalData, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/NewMembership/CreateNewClubMembership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withDuplicateCheck !== undefined) {
                localVarQueryParameter['withDuplicateCheck'] = withDuplicateCheck;
            }
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeigth !== undefined) {
                localVarQueryParameter['photoHeigth'] = photoHeigth;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(personalData, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {ReCaptchaRequest} [recaptchaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipCreateNewClubMembershipReCaptcha: (recaptchaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/NewMembership/CreateNewClubMembershipReCaptcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recaptchaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} pdf
         * @param {number} [photoWidth]
         * @param {number} [photoHeight]
         * @param {NewMembershipRequest} [newMembershipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipRegisterNewAddress: (pdf, photoWidth, photoHeight, newMembershipRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pdf' is not null or undefined
            assertParamExists('newMembershipRegisterNewAddress', 'pdf', pdf);
            const localVarPath = `/api/NewMembership/RegisterNewAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (pdf !== undefined) {
                localVarQueryParameter['pdf'] = pdf;
            }
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeight !== undefined) {
                localVarQueryParameter['photoHeight'] = photoHeight;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(newMembershipRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * NewMembershipApi - functional programming interface
 * @export
 */
export const NewMembershipApiFp = function (configuration) {
    const localVarAxiosParamCreator = NewMembershipApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {number} clubNum
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipConfirmAddressRegistration(id, clubNum, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newMembershipConfirmAddressRegistration(id, clubNum, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {boolean} [withDuplicateCheck]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {ClubAddressMember} [personalData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipCreateNewClubMembership(withDuplicateCheck, photoWidth, photoHeigth, personalData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newMembershipCreateNewClubMembership(withDuplicateCheck, photoWidth, photoHeigth, personalData, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {ReCaptchaRequest} [recaptchaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipCreateNewClubMembershipReCaptcha(recaptchaRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newMembershipCreateNewClubMembershipReCaptcha(recaptchaRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} pdf
         * @param {number} [photoWidth]
         * @param {number} [photoHeight]
         * @param {NewMembershipRequest} [newMembershipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipRegisterNewAddress(pdf, photoWidth, photoHeight, newMembershipRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.newMembershipRegisterNewAddress(pdf, photoWidth, photoHeight, newMembershipRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * NewMembershipApi - factory interface
 * @export
 */
export const NewMembershipApiFactory = function (configuration, basePath, axios) {
    const localVarFp = NewMembershipApiFp(configuration);
    return {
        /**
         *
         * @param {string} id
         * @param {number} clubNum
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipConfirmAddressRegistration(id, clubNum, options) {
            return localVarFp.newMembershipConfirmAddressRegistration(id, clubNum, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {boolean} [withDuplicateCheck]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {ClubAddressMember} [personalData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipCreateNewClubMembership(withDuplicateCheck, photoWidth, photoHeigth, personalData, options) {
            return localVarFp.newMembershipCreateNewClubMembership(withDuplicateCheck, photoWidth, photoHeigth, personalData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {ReCaptchaRequest} [recaptchaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipCreateNewClubMembershipReCaptcha(recaptchaRequest, options) {
            return localVarFp.newMembershipCreateNewClubMembershipReCaptcha(recaptchaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} pdf
         * @param {number} [photoWidth]
         * @param {number} [photoHeight]
         * @param {NewMembershipRequest} [newMembershipRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newMembershipRegisterNewAddress(pdf, photoWidth, photoHeight, newMembershipRequest, options) {
            return localVarFp.newMembershipRegisterNewAddress(pdf, photoWidth, photoHeight, newMembershipRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * NewMembershipApi - object-oriented interface
 * @export
 * @class NewMembershipApi
 * @extends {BaseAPI}
 */
export class NewMembershipApi extends BaseAPI {
    /**
     *
     * @param {string} id
     * @param {number} clubNum
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewMembershipApi
     */
    newMembershipConfirmAddressRegistration(id, clubNum, options) {
        return NewMembershipApiFp(this.configuration).newMembershipConfirmAddressRegistration(id, clubNum, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {boolean} [withDuplicateCheck]
     * @param {number} [photoWidth]
     * @param {number} [photoHeigth]
     * @param {ClubAddressMember} [personalData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewMembershipApi
     */
    newMembershipCreateNewClubMembership(withDuplicateCheck, photoWidth, photoHeigth, personalData, options) {
        return NewMembershipApiFp(this.configuration).newMembershipCreateNewClubMembership(withDuplicateCheck, photoWidth, photoHeigth, personalData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {ReCaptchaRequest} [recaptchaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewMembershipApi
     */
    newMembershipCreateNewClubMembershipReCaptcha(recaptchaRequest, options) {
        return NewMembershipApiFp(this.configuration).newMembershipCreateNewClubMembershipReCaptcha(recaptchaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} pdf
     * @param {number} [photoWidth]
     * @param {number} [photoHeight]
     * @param {NewMembershipRequest} [newMembershipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewMembershipApi
     */
    newMembershipRegisterNewAddress(pdf, photoWidth, photoHeight, newMembershipRequest, options) {
        return NewMembershipApiFp(this.configuration).newMembershipRegisterNewAddress(pdf, photoWidth, photoHeight, newMembershipRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OpenGeoApi - axios parameter creator
 * @export
 */
export const OpenGeoApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetCityByCoordinates: (latitude, longitude, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('openGeoGetCityByCoordinates', 'latitude', latitude);
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('openGeoGetCityByCoordinates', 'longitude', longitude);
            const localVarPath = `/api/OpenGeo/City`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }
            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [loadClubLogo]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetClubData: (clubNumber, loadClubLogo, logoWidth, logoHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('openGeoGetClubData', 'clubNumber', clubNumber);
            const localVarPath = `/api/OpenGeo/GetClubData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            if (loadClubLogo !== undefined) {
                localVarQueryParameter['loadClubLogo'] = loadClubLogo;
            }
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} range
         * @param {number} postcode
         * @param {string} [city]
         * @param {string} [department]
         * @param {boolean} [excludeMode]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetClubsInRange: (range, postcode, city, department, excludeMode, logoWidth, logoHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'range' is not null or undefined
            assertParamExists('openGeoGetClubsInRange', 'range', range);
            // verify required parameter 'postcode' is not null or undefined
            assertParamExists('openGeoGetClubsInRange', 'postcode', postcode);
            const localVarPath = `/api/OpenGeo/ClubsInRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }
            if (postcode !== undefined) {
                localVarQueryParameter['postcode'] = postcode;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }
            if (excludeMode !== undefined) {
                localVarQueryParameter['excludeMode'] = excludeMode;
            }
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} range
         * @param {number} postcode
         * @param {string} city
         * @param {boolean} [excludeMode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetPostcodesInRange: (range, postcode, city, excludeMode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'range' is not null or undefined
            assertParamExists('openGeoGetPostcodesInRange', 'range', range);
            // verify required parameter 'postcode' is not null or undefined
            assertParamExists('openGeoGetPostcodesInRange', 'postcode', postcode);
            // verify required parameter 'city' is not null or undefined
            assertParamExists('openGeoGetPostcodesInRange', 'city', city);
            const localVarPath = `/api/OpenGeo/PostcodesInRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }
            if (postcode !== undefined) {
                localVarQueryParameter['postcode'] = postcode;
            }
            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }
            if (excludeMode !== undefined) {
                localVarQueryParameter['excludeMode'] = excludeMode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OpenGeoApi - functional programming interface
 * @export
 */
export const OpenGeoApiFp = function (configuration) {
    const localVarAxiosParamCreator = OpenGeoApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetCityByCoordinates(latitude, longitude, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.openGeoGetCityByCoordinates(latitude, longitude, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [loadClubLogo]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetClubData(clubNumber, loadClubLogo, logoWidth, logoHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.openGeoGetClubData(clubNumber, loadClubLogo, logoWidth, logoHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} range
         * @param {number} postcode
         * @param {string} [city]
         * @param {string} [department]
         * @param {boolean} [excludeMode]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetClubsInRange(range, postcode, city, department, excludeMode, logoWidth, logoHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.openGeoGetClubsInRange(range, postcode, city, department, excludeMode, logoWidth, logoHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} range
         * @param {number} postcode
         * @param {string} city
         * @param {boolean} [excludeMode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetPostcodesInRange(range, postcode, city, excludeMode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.openGeoGetPostcodesInRange(range, postcode, city, excludeMode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OpenGeoApi - factory interface
 * @export
 */
export const OpenGeoApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OpenGeoApiFp(configuration);
    return {
        /**
         *
         * @param {number} latitude
         * @param {number} longitude
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetCityByCoordinates(latitude, longitude, options) {
            return localVarFp.openGeoGetCityByCoordinates(latitude, longitude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [loadClubLogo]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetClubData(clubNumber, loadClubLogo, logoWidth, logoHeigth, options) {
            return localVarFp.openGeoGetClubData(clubNumber, loadClubLogo, logoWidth, logoHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} range
         * @param {number} postcode
         * @param {string} [city]
         * @param {string} [department]
         * @param {boolean} [excludeMode]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetClubsInRange(range, postcode, city, department, excludeMode, logoWidth, logoHeigth, options) {
            return localVarFp.openGeoGetClubsInRange(range, postcode, city, department, excludeMode, logoWidth, logoHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} range
         * @param {number} postcode
         * @param {string} city
         * @param {boolean} [excludeMode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openGeoGetPostcodesInRange(range, postcode, city, excludeMode, options) {
            return localVarFp.openGeoGetPostcodesInRange(range, postcode, city, excludeMode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OpenGeoApi - object-oriented interface
 * @export
 * @class OpenGeoApi
 * @extends {BaseAPI}
 */
export class OpenGeoApi extends BaseAPI {
    /**
     *
     * @param {number} latitude
     * @param {number} longitude
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenGeoApi
     */
    openGeoGetCityByCoordinates(latitude, longitude, options) {
        return OpenGeoApiFp(this.configuration).openGeoGetCityByCoordinates(latitude, longitude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {boolean} [loadClubLogo]
     * @param {number} [logoWidth]
     * @param {number} [logoHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenGeoApi
     */
    openGeoGetClubData(clubNumber, loadClubLogo, logoWidth, logoHeigth, options) {
        return OpenGeoApiFp(this.configuration).openGeoGetClubData(clubNumber, loadClubLogo, logoWidth, logoHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} range
     * @param {number} postcode
     * @param {string} [city]
     * @param {string} [department]
     * @param {boolean} [excludeMode]
     * @param {number} [logoWidth]
     * @param {number} [logoHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenGeoApi
     */
    openGeoGetClubsInRange(range, postcode, city, department, excludeMode, logoWidth, logoHeigth, options) {
        return OpenGeoApiFp(this.configuration).openGeoGetClubsInRange(range, postcode, city, department, excludeMode, logoWidth, logoHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} range
     * @param {number} postcode
     * @param {string} city
     * @param {boolean} [excludeMode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpenGeoApi
     */
    openGeoGetPostcodesInRange(range, postcode, city, excludeMode, options) {
        return OpenGeoApiFp(this.configuration).openGeoGetPostcodesInRange(range, postcode, city, excludeMode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} orderId
         * @param {number} clubNumber
         * @param {KlarnaCaptureOrder} [captureOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCaptureKlarnaOrder: (orderId, clubNumber, captureOrder, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('paymentCaptureKlarnaOrder', 'orderId', orderId);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('paymentCaptureKlarnaOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/Payment/Klarna/CaptureOrder/{orderId}/{clubNumber}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(captureOrder, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCapturePaypalOrder: (clubNumber, captureOrderInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('paymentCapturePaypalOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/Payment/Paypal/CaptureOrder/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(captureOrderInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {KlarnaSession} [klarnaSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCreateKlarnaSession: (clubNumber, klarnaSession, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('paymentCreateKlarnaSession', 'clubNumber', clubNumber);
            const localVarPath = `/api/Payment/Klarna/CreateSession/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(klarnaSession, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCreatePaypalOrder: (clubNumber, createOrderInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('paymentCreatePaypalOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/Payment/Paypal/CreateOrder/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderInput, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderId
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetKlarnaOrder: (orderId, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('paymentGetKlarnaOrder', 'orderId', orderId);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('paymentGetKlarnaOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/Payment/Klarna/GetOrder/{orderId}/{clubNumber}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetPaymentOptions: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('paymentGetPaymentOptions', 'clubNumber', clubNumber);
            const localVarPath = `/api/Payment/PaymentOptions/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {KlarnaOrderPlacement} [klarnaOrderPlacement]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlaceKlarnaOrder: (clubNumber, klarnaOrderPlacement, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('paymentPlaceKlarnaOrder', 'clubNumber', clubNumber);
            const localVarPath = `/api/Payment/Klarna/PlaceOrder/{clubNumber}`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(klarnaOrderPlacement, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function (configuration) {
    const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} orderId
         * @param {number} clubNumber
         * @param {KlarnaCaptureOrder} [captureOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCaptureKlarnaOrder(orderId, clubNumber, captureOrder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentCaptureKlarnaOrder(orderId, clubNumber, captureOrder, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCapturePaypalOrder(clubNumber, captureOrderInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentCapturePaypalOrder(clubNumber, captureOrderInput, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {KlarnaSession} [klarnaSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCreateKlarnaSession(clubNumber, klarnaSession, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentCreateKlarnaSession(clubNumber, klarnaSession, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCreatePaypalOrder(clubNumber, createOrderInput, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentCreatePaypalOrder(clubNumber, createOrderInput, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetKlarnaOrder(orderId, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentGetKlarnaOrder(orderId, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetPaymentOptions(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentGetPaymentOptions(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {KlarnaOrderPlacement} [klarnaOrderPlacement]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlaceKlarnaOrder(clubNumber, klarnaOrderPlacement, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentPlaceKlarnaOrder(clubNumber, klarnaOrderPlacement, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PaymentApiFp(configuration);
    return {
        /**
         *
         * @param {string} orderId
         * @param {number} clubNumber
         * @param {KlarnaCaptureOrder} [captureOrder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCaptureKlarnaOrder(orderId, clubNumber, captureOrder, options) {
            return localVarFp.paymentCaptureKlarnaOrder(orderId, clubNumber, captureOrder, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCaptureOrderInput} [captureOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCapturePaypalOrder(clubNumber, captureOrderInput, options) {
            return localVarFp.paymentCapturePaypalOrder(clubNumber, captureOrderInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {KlarnaSession} [klarnaSession]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCreateKlarnaSession(clubNumber, klarnaSession, options) {
            return localVarFp.paymentCreateKlarnaSession(clubNumber, klarnaSession, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PayPalCreateOrderInput} [createOrderInput]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCreatePaypalOrder(clubNumber, createOrderInput, options) {
            return localVarFp.paymentCreatePaypalOrder(clubNumber, createOrderInput, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} orderId
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetKlarnaOrder(orderId, clubNumber, options) {
            return localVarFp.paymentGetKlarnaOrder(orderId, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentGetPaymentOptions(clubNumber, options) {
            return localVarFp.paymentGetPaymentOptions(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {KlarnaOrderPlacement} [klarnaOrderPlacement]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentPlaceKlarnaOrder(clubNumber, klarnaOrderPlacement, options) {
            return localVarFp.paymentPlaceKlarnaOrder(clubNumber, klarnaOrderPlacement, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
    /**
     *
     * @param {string} orderId
     * @param {number} clubNumber
     * @param {KlarnaCaptureOrder} [captureOrder]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    paymentCaptureKlarnaOrder(orderId, clubNumber, captureOrder, options) {
        return PaymentApiFp(this.configuration).paymentCaptureKlarnaOrder(orderId, clubNumber, captureOrder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {PayPalCaptureOrderInput} [captureOrderInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    paymentCapturePaypalOrder(clubNumber, captureOrderInput, options) {
        return PaymentApiFp(this.configuration).paymentCapturePaypalOrder(clubNumber, captureOrderInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {KlarnaSession} [klarnaSession]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    paymentCreateKlarnaSession(clubNumber, klarnaSession, options) {
        return PaymentApiFp(this.configuration).paymentCreateKlarnaSession(clubNumber, klarnaSession, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {PayPalCreateOrderInput} [createOrderInput]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    paymentCreatePaypalOrder(clubNumber, createOrderInput, options) {
        return PaymentApiFp(this.configuration).paymentCreatePaypalOrder(clubNumber, createOrderInput, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} orderId
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    paymentGetKlarnaOrder(orderId, clubNumber, options) {
        return PaymentApiFp(this.configuration).paymentGetKlarnaOrder(orderId, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    paymentGetPaymentOptions(clubNumber, options) {
        return PaymentApiFp(this.configuration).paymentGetPaymentOptions(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {KlarnaOrderPlacement} [klarnaOrderPlacement]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    paymentPlaceKlarnaOrder(clubNumber, klarnaOrderPlacement, options) {
        return PaymentApiFp(this.configuration).paymentPlaceKlarnaOrder(clubNumber, klarnaOrderPlacement, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PeAnApi - axios parameter creator
 * @export
 */
export const PeAnApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ReCaptchaRequest} [recaptchaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peAnCreateNewClubMembership: (recaptchaRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/PeAn/CreateNewClubMembership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recaptchaRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peAnGetConfig: (vereinsNummer, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vereinsNummer' is not null or undefined
            assertParamExists('peAnGetConfig', 'vereinsNummer', vereinsNummer);
            const localVarPath = `/api/PeAn/GetConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (vereinsNummer !== undefined) {
                localVarQueryParameter['vereinsNummer'] = vereinsNummer;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PeAnApi - functional programming interface
 * @export
 */
export const PeAnApiFp = function (configuration) {
    const localVarAxiosParamCreator = PeAnApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {ReCaptchaRequest} [recaptchaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peAnCreateNewClubMembership(recaptchaRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.peAnCreateNewClubMembership(recaptchaRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peAnGetConfig(vereinsNummer, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.peAnGetConfig(vereinsNummer, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PeAnApi - factory interface
 * @export
 */
export const PeAnApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PeAnApiFp(configuration);
    return {
        /**
         *
         * @param {ReCaptchaRequest} [recaptchaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peAnCreateNewClubMembership(recaptchaRequest, options) {
            return localVarFp.peAnCreateNewClubMembership(recaptchaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} vereinsNummer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        peAnGetConfig(vereinsNummer, options) {
            return localVarFp.peAnGetConfig(vereinsNummer, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PeAnApi - object-oriented interface
 * @export
 * @class PeAnApi
 * @extends {BaseAPI}
 */
export class PeAnApi extends BaseAPI {
    /**
     *
     * @param {ReCaptchaRequest} [recaptchaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeAnApi
     */
    peAnCreateNewClubMembership(recaptchaRequest, options) {
        return PeAnApiFp(this.configuration).peAnCreateNewClubMembership(recaptchaRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} vereinsNummer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeAnApi
     */
    peAnGetConfig(vereinsNummer, options) {
        return PeAnApiFp(this.configuration).peAnGetConfig(vereinsNummer, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PersonalDataApi - axios parameter creator
 * @export
 */
export const PersonalDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} message
         * @param {string} fromDate
         * @param {boolean} asFamily
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataCreateMemberShip: (message, fromDate, asFamily, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('personalDataCreateMemberShip', 'message', message);
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('personalDataCreateMemberShip', 'fromDate', fromDate);
            // verify required parameter 'asFamily' is not null or undefined
            assertParamExists('personalDataCreateMemberShip', 'asFamily', asFamily);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataCreateMemberShip', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/MemberShip`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (message !== undefined) {
                localVarQueryParameter['message'] = message;
            }
            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate instanceof Date) ?
                    fromDate.toISOString() :
                    fromDate;
            }
            if (asFamily !== undefined) {
                localVarQueryParameter['asFamily'] = asFamily;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadAdditionalPersonalClubData: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataLoadAdditionalPersonalClubData', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/AdditionalPersonalClubData`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {boolean} [loadClubLogo]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {boolean} [autoScaleLogo]
         * @param {string} [culture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadClubIdCardData: (clubNumber, photoWidth, photoHeigth, loadClubLogo, logoWidth, logoHeigth, autoScaleLogo, culture, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataLoadClubIdCardData', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/ClubIdCardData`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeigth !== undefined) {
                localVarQueryParameter['photoHeigth'] = photoHeigth;
            }
            if (loadClubLogo !== undefined) {
                localVarQueryParameter['loadClubLogo'] = loadClubLogo;
            }
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            if (autoScaleLogo !== undefined) {
                localVarQueryParameter['autoScaleLogo'] = autoScaleLogo;
            }
            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadMembershipData: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataLoadMembershipData', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/MembershipData`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPayerAccount: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataLoadPayerAccount', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/PayerAccount`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPersonaBankAccounts: (clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataLoadPersonaBankAccounts', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/BankAccounts`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPersonalData: (clubNumber, withPhoto, photoWidth, photoHeigth, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataLoadPersonalData', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/PersonalData`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withPhoto !== undefined) {
                localVarQueryParameter['withPhoto'] = withPhoto;
            }
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeigth !== undefined) {
                localVarQueryParameter['photoHeigth'] = photoHeigth;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} message
         * @param {string} membershipId
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataRemoveMemberShip: (message, membershipId, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'message' is not null or undefined
            assertParamExists('personalDataRemoveMemberShip', 'message', message);
            // verify required parameter 'membershipId' is not null or undefined
            assertParamExists('personalDataRemoveMemberShip', 'membershipId', membershipId);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataRemoveMemberShip', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/MemberShip/{membershipId}/Remove`
                .replace(`{${"membershipId"}}`, encodeURIComponent(String(membershipId)))
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (message !== undefined) {
                localVarQueryParameter['message'] = message;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} bankAccountId
         * @param {string} accountMessage
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataRemovePersonalBankAccount: (bankAccountId, accountMessage, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'bankAccountId' is not null or undefined
            assertParamExists('personalDataRemovePersonalBankAccount', 'bankAccountId', bankAccountId);
            // verify required parameter 'accountMessage' is not null or undefined
            assertParamExists('personalDataRemovePersonalBankAccount', 'accountMessage', accountMessage);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataRemovePersonalBankAccount', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/BankAccount/{bankAccountId}/Remove`
                .replace(`{${"bankAccountId"}}`, encodeURIComponent(String(bankAccountId)))
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (accountMessage !== undefined) {
                localVarQueryParameter['accountMessage'] = accountMessage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {PersonalBankAccount} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataSavePersonalBankAccount: (clubNumber, data, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataSavePersonalBankAccount', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/BankAccount`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {PersonalAddressData} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataSavePersonalData: (clubNumber, withPhoto, photoWidth, photoHeigth, data, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('personalDataSavePersonalData', 'clubNumber', clubNumber);
            const localVarPath = `/api/PersonalData/{clubNumber}/PersonalData`
                .replace(`{${"clubNumber"}}`, encodeURIComponent(String(clubNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (withPhoto !== undefined) {
                localVarQueryParameter['withPhoto'] = withPhoto;
            }
            if (photoWidth !== undefined) {
                localVarQueryParameter['photoWidth'] = photoWidth;
            }
            if (photoHeigth !== undefined) {
                localVarQueryParameter['photoHeigth'] = photoHeigth;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PersonalDataApi - functional programming interface
 * @export
 */
export const PersonalDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = PersonalDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} message
         * @param {string} fromDate
         * @param {boolean} asFamily
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataCreateMemberShip(message, fromDate, asFamily, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataCreateMemberShip(message, fromDate, asFamily, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadAdditionalPersonalClubData(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataLoadAdditionalPersonalClubData(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {boolean} [loadClubLogo]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {boolean} [autoScaleLogo]
         * @param {string} [culture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadClubIdCardData(clubNumber, photoWidth, photoHeigth, loadClubLogo, logoWidth, logoHeigth, autoScaleLogo, culture, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataLoadClubIdCardData(clubNumber, photoWidth, photoHeigth, loadClubLogo, logoWidth, logoHeigth, autoScaleLogo, culture, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadMembershipData(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataLoadMembershipData(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPayerAccount(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataLoadPayerAccount(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPersonaBankAccounts(clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataLoadPersonaBankAccounts(clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} message
         * @param {string} membershipId
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataRemoveMemberShip(message, membershipId, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataRemoveMemberShip(message, membershipId, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} bankAccountId
         * @param {string} accountMessage
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataRemovePersonalBankAccount(bankAccountId, accountMessage, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataRemovePersonalBankAccount(bankAccountId, accountMessage, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PersonalBankAccount} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataSavePersonalBankAccount(clubNumber, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataSavePersonalBankAccount(clubNumber, data, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {PersonalAddressData} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataSavePersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, data, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.personalDataSavePersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, data, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PersonalDataApi - factory interface
 * @export
 */
export const PersonalDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PersonalDataApiFp(configuration);
    return {
        /**
         *
         * @param {string} message
         * @param {string} fromDate
         * @param {boolean} asFamily
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataCreateMemberShip(message, fromDate, asFamily, clubNumber, options) {
            return localVarFp.personalDataCreateMemberShip(message, fromDate, asFamily, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadAdditionalPersonalClubData(clubNumber, options) {
            return localVarFp.personalDataLoadAdditionalPersonalClubData(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {boolean} [loadClubLogo]
         * @param {number} [logoWidth]
         * @param {number} [logoHeigth]
         * @param {boolean} [autoScaleLogo]
         * @param {string} [culture]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadClubIdCardData(clubNumber, photoWidth, photoHeigth, loadClubLogo, logoWidth, logoHeigth, autoScaleLogo, culture, options) {
            return localVarFp.personalDataLoadClubIdCardData(clubNumber, photoWidth, photoHeigth, loadClubLogo, logoWidth, logoHeigth, autoScaleLogo, culture, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadMembershipData(clubNumber, options) {
            return localVarFp.personalDataLoadMembershipData(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPayerAccount(clubNumber, options) {
            return localVarFp.personalDataLoadPayerAccount(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPersonaBankAccounts(clubNumber, options) {
            return localVarFp.personalDataLoadPersonaBankAccounts(clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
            return localVarFp.personalDataLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} message
         * @param {string} membershipId
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataRemoveMemberShip(message, membershipId, clubNumber, options) {
            return localVarFp.personalDataRemoveMemberShip(message, membershipId, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} bankAccountId
         * @param {string} accountMessage
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataRemovePersonalBankAccount(bankAccountId, accountMessage, clubNumber, options) {
            return localVarFp.personalDataRemovePersonalBankAccount(bankAccountId, accountMessage, clubNumber, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {PersonalBankAccount} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataSavePersonalBankAccount(clubNumber, data, options) {
            return localVarFp.personalDataSavePersonalBankAccount(clubNumber, data, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} clubNumber
         * @param {boolean} [withPhoto]
         * @param {number} [photoWidth]
         * @param {number} [photoHeigth]
         * @param {PersonalAddressData} [data]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        personalDataSavePersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, data, options) {
            return localVarFp.personalDataSavePersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, data, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PersonalDataApi - object-oriented interface
 * @export
 * @class PersonalDataApi
 * @extends {BaseAPI}
 */
export class PersonalDataApi extends BaseAPI {
    /**
     *
     * @param {string} message
     * @param {string} fromDate
     * @param {boolean} asFamily
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataCreateMemberShip(message, fromDate, asFamily, clubNumber, options) {
        return PersonalDataApiFp(this.configuration).personalDataCreateMemberShip(message, fromDate, asFamily, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataLoadAdditionalPersonalClubData(clubNumber, options) {
        return PersonalDataApiFp(this.configuration).personalDataLoadAdditionalPersonalClubData(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {number} [photoWidth]
     * @param {number} [photoHeigth]
     * @param {boolean} [loadClubLogo]
     * @param {number} [logoWidth]
     * @param {number} [logoHeigth]
     * @param {boolean} [autoScaleLogo]
     * @param {string} [culture]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataLoadClubIdCardData(clubNumber, photoWidth, photoHeigth, loadClubLogo, logoWidth, logoHeigth, autoScaleLogo, culture, options) {
        return PersonalDataApiFp(this.configuration).personalDataLoadClubIdCardData(clubNumber, photoWidth, photoHeigth, loadClubLogo, logoWidth, logoHeigth, autoScaleLogo, culture, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataLoadMembershipData(clubNumber, options) {
        return PersonalDataApiFp(this.configuration).personalDataLoadMembershipData(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataLoadPayerAccount(clubNumber, options) {
        return PersonalDataApiFp(this.configuration).personalDataLoadPayerAccount(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataLoadPersonaBankAccounts(clubNumber, options) {
        return PersonalDataApiFp(this.configuration).personalDataLoadPersonaBankAccounts(clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {boolean} [withPhoto]
     * @param {number} [photoWidth]
     * @param {number} [photoHeigth]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options) {
        return PersonalDataApiFp(this.configuration).personalDataLoadPersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} message
     * @param {string} membershipId
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataRemoveMemberShip(message, membershipId, clubNumber, options) {
        return PersonalDataApiFp(this.configuration).personalDataRemoveMemberShip(message, membershipId, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} bankAccountId
     * @param {string} accountMessage
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataRemovePersonalBankAccount(bankAccountId, accountMessage, clubNumber, options) {
        return PersonalDataApiFp(this.configuration).personalDataRemovePersonalBankAccount(bankAccountId, accountMessage, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {PersonalBankAccount} [data]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataSavePersonalBankAccount(clubNumber, data, options) {
        return PersonalDataApiFp(this.configuration).personalDataSavePersonalBankAccount(clubNumber, data, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} clubNumber
     * @param {boolean} [withPhoto]
     * @param {number} [photoWidth]
     * @param {number} [photoHeigth]
     * @param {PersonalAddressData} [data]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalDataApi
     */
    personalDataSavePersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, data, options) {
        return PersonalDataApiFp(this.configuration).personalDataSavePersonalData(clubNumber, withPhoto, photoWidth, photoHeigth, data, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PublicDataApi - axios parameter creator
 * @export
 */
export const PublicDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicDataGetClubData: (logoWidth, logoHeigth, clubNumber, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'logoWidth' is not null or undefined
            assertParamExists('publicDataGetClubData', 'logoWidth', logoWidth);
            // verify required parameter 'logoHeigth' is not null or undefined
            assertParamExists('publicDataGetClubData', 'logoHeigth', logoHeigth);
            // verify required parameter 'clubNumber' is not null or undefined
            assertParamExists('publicDataGetClubData', 'clubNumber', clubNumber);
            const localVarPath = `/api/PublicData/GetClubData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT Token required
            yield setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (logoWidth !== undefined) {
                localVarQueryParameter['logoWidth'] = logoWidth;
            }
            if (logoHeigth !== undefined) {
                localVarQueryParameter['logoHeigth'] = logoHeigth;
            }
            if (clubNumber !== undefined) {
                localVarQueryParameter['clubNumber'] = clubNumber;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PublicDataApi - functional programming interface
 * @export
 */
export const PublicDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = PublicDataApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicDataGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.publicDataGetClubData(logoWidth, logoHeigth, clubNumber, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PublicDataApi - factory interface
 * @export
 */
export const PublicDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PublicDataApiFp(configuration);
    return {
        /**
         *
         * @param {number} logoWidth
         * @param {number} logoHeigth
         * @param {number} clubNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicDataGetClubData(logoWidth, logoHeigth, clubNumber, options) {
            return localVarFp.publicDataGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PublicDataApi - object-oriented interface
 * @export
 * @class PublicDataApi
 * @extends {BaseAPI}
 */
export class PublicDataApi extends BaseAPI {
    /**
     *
     * @param {number} logoWidth
     * @param {number} logoHeigth
     * @param {number} clubNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicDataApi
     */
    publicDataGetClubData(logoWidth, logoHeigth, clubNumber, options) {
        return PublicDataApiFp(this.configuration).publicDataGetClubData(logoWidth, logoHeigth, clubNumber, options).then((request) => request(this.axios, this.basePath));
    }
}
